import { app_server } from './EnvConfig';

//组织架构
export const sysOrg_getSysOrg = app_server + '/sysOrg/getSysOrg';    //组织架构列表
export const sysOrg_saveSysOrg = app_server + '/sysOrg/saveSysOrg';  //新增/编辑组织架构
export const sysOrg_delSysOrg = app_server + '/sysOrg/delSysOrg';    //删除
export const sys_roleList = app_server + '/sys/roleList';        //角色列表
export const sys_getSysRole = app_server + '/sys/getSysRole';
export const sysRole_saveSysRole = app_server + '/sysRole/saveSysRole';   //新增编辑角色
export const sysMeun_meun = app_server + '/sysMeun/meun';             //功能列表
export const sysRole_getSysRoleByOrg = app_server + '/sysRole/getSysRoleByOrg';   //查询当前角色权限
export const sysRole_delSysRole = app_server + '/sysRole/delSysRole';   //角色删除
export const sysMeun_getSelectMeunByRole = app_server + '/sysMeun/getSelectMeunByRole';   //角色删除
export const back_user_back_user_export = app_server + '/back_user/back_user_export';   //员工账号导出
export const sys_getSelectBtnByRole = app_server + '/sysMeun/getSelectBtnByRole';   //角色按钮回显

//大项目部
export const projectManagement_updateTemplateId = app_server + '/projectManagement/updateTemplateId';   //修改项目等级（重点项目，常规项目，小微项目）
export const projectManagement_distribute_project = app_server + '/projectManagement/distribute_project';   //cqo分配大项目
export const projectManagement_receipt_project = app_server + '/projectManagement/receipt_project';   //cqo分配大项目
export const projectManagement_distribute_project_page = app_server + '/projectManagement/distribute_project_page';   //项目分配列表
export const projectManagement_receipt_project_page = app_server + '/projectManagement/receipt_project_page';
export const projectManagement_distribute_project_export = app_server + '/projectManagement/distribute_project_export';  //导出
export const projectManagement_receipt_project_export = app_server + '/projectManagement/receipt_project_export';  //导出

export const introducer_changeIntroducer = app_server + '/introducer/changeIntroducer';  //接触介绍人
export const introducer_pm_noneIntroducer_page = app_server + '/introducer/pm_noneIntroducer_page';  //查询没有上级介绍人的正式项目总监
export const introducer_editIntroducer = app_server + '/introducer/editIntroducer';  //添加团队成员
export const contractInfo_editContractRemark = app_server + '/contractInfo/editContractRemark';

export const apply_addUploadAttachAgain = app_server + '/apply/addUploadAttachAgain';

export const contractInfo_new_upload_attach = app_server + '/contractInfo/new_upload_attach'; //新上传附件
export const new_upload_attach = app_server + '/attach/new_upload_attach'; //新上传附件
export const projectManagement_getCmList = app_server + '/projectManagement/getCmList'; //客户经理列表
export const customer_getCmList = app_server + '/customer/getCreateUserId'; //甲方创建人搜索下拉列表，系统所有的客户经理、营销经理角色姓名





export const contractInfo_updateProjectDocDirTitle = app_server + '/contractInfo/updateProjectDocDirTitle'; //客户经理列表
//合作公司管理
export const cooperation_add = app_server + '/customerCooperation/addOrUpdate'; //新增合作公司
export const cooperation_type = app_server + '/customerCooperation/getCreateUserId'; //获取类型
export const cooperation_list = app_server + '/customerCooperation/getPagesUI'; //获取合作公司列表
export const cooperation_del = app_server + '/customerCooperation/deleteCustomerCooperationShareholder'; //删除合作公司
export const cooperation_view = app_server + '/customerCooperation/findById'; //删除合作公司

// 字典管理开关
export const enum_switchPaddles = app_server + '/enum_data/switchPaddles';
















// ===== 登录相关
export const user_login = app_server + '/login';
export const user_logout = app_server + '/logout';
export const mock_income_test = app_server + '/project_income/mock_test';
export const reset_pwd = app_server + '/reset_password';
export const login_code = app_server + '/sendLoginSmsCode';
export const login_by_code = app_server + '/loginByPhone';
export const wx_login_code = app_server + '/wxLoginSmsCode';
export const wxlogin_qrcode = app_server + '/wxlogin_qrcode';
export const scan_poll = app_server + '/scan_poll';
export const token_login_info = app_server + '/token_login_info';
export const captcha = app_server + '/captcha';
export const checkCaptcha = app_server + '/checkCaptcha';
export const exist_phone_account = app_server + '/forgotpwd/exist_phone_account';

//新美微信端待办相关
export const wx_user_login = app_server + '/wxPhoneLogin';
export const wx_auto_login = app_server + '/wxAutoLogin';
export const wx_user_info = app_server + '/back_user/getBackUserInfo';
export const wx_remove_info = app_server + '/back_user/wxBindingLift';



//保险劳务公司
export const enum_data_find_insurance_labor_company = app_server + '/customer/find_insurance_labor_labor';
export const enum_data_find_insurance_labor_ins = app_server + '/customer/find_insurance_labor_ins';

export const bill_material_uploadExcelBill_check = app_server + '/bill_material/uploadExcelBill_check';
export const bill_material_uploadExcelBillMaterials_save = app_server + '/bill_material/uploadExcelBillMaterials_save';



// ===== 权限角色相关
export const back_user_page_data = app_server + '/back_user/page_data';
export const back_user_get_by_id = app_server + '/back_user/get';
export const back_user_save = app_server + '/back_user/save';
export const back_user_toggle_status = app_server + '/back_user/toggle_status';
export const back_user_context_data = app_server + '/back_user/context_data';   // 预备数据
export const back_user_getAll = app_server + '/back_user/getAll';
export const back_user_page_pm_data = app_server + '/back_user/page_pm_data';//项目总监列表数据
export const back_user_save_pm = app_server + '/back_user/save_pm';//编辑项目总监保存
export const back_user_cmInfo = app_server + '/back_user/findCmInfo';//查看客户经理详情
export const back_user_pm_list = app_server + '/back_user/findCmProjectManagerList';//查看客户经理下面的项目总监
export const back_user_project_list = app_server + '/back_user/findCmProjectList';//查看客户经理下面的项目
export const back_useRcm_page_data = app_server + '/back_user/cm_page_data'
// ===== 我的情况
export const me_change_password = app_server + '/me/change_password';

// ===== 枚举分类相关
export const enum_cat_page_data = app_server + '/enum_cat/page_data';
export const enum_cat_get_by_id = app_server + '/enum_cat/get';
export const enum_cat_save = app_server + '/enum_cat/save';
export const enum_cat_delete = app_server + '/enum_cat/delete';

// ===== 枚举数据相关
export const enum_data_page_data = app_server + '/enum_data/page_data';
export const enum_data_get_by_id = app_server + '/enum_data/get';
export const enum_data_save = app_server + '/enum_data/save';
export const enum_data_disabled = app_server + '/enum_data/disabled';
export const enum_data_delete = app_server + '/enum_data/delete';
export const enum_data_move = app_server + '/enum_data/move';
export const enum_data_get_by_catId = app_server + '/enum_data/getEnumByCarId';
export const enum_data_type = app_server + '/type_selection';
export const getAuditObjectByItemCode = app_server + '/flow/getAuditObjectByItemCode';//流程组件审批信息
export const getAuditObjectByBizItemId = app_server + '/flow/getAuditObjectByBizItemId';//流程组件审批信息
export const flow_review = app_server + '/flow/review';//抄送环节批阅接口
export const find_register_platform_type = app_server + '/enum_data/find_register_platform_type';
export const find_company_nature_type = app_server + '/enum_data/find_company_nature_type';
export const status_option_list = app_server + '/apply/getPaymentStatus'  //付款状态下拉框列表
export const xmcom_list = app_server + '/subsidiaryCompany/getCompanyList'  //付款公司下拉框列表
export const import_status_channel = app_server + '/applyData/getImportStatus'  //材料导入状态
export const dispatch_status_channel = app_server + '/projectManagement/getDispatchType'  //派单状态下拉框列表
export const all_enum_data = app_server + '/project/getAllEnumData'   //勘误页面下拉框数据
export const zhoty_credit_pay_status = app_server + '/credit/getZhotyCreditPayStatusCats'  //状态



// ===== 银行名称数据相关
export const bankNameData_data = app_server + '/bankName_data/page_data';
export const bankNameData_get_by_id = app_server + '/bankName_data/get';
export const bankNameData_save = app_server + '/bankName_data/save';
export const bankNameData_delete = app_server + '/bankName_data/delete';
export const bankNameData_getAll = app_server + '/bankName_data/getAll';
export const bankAccount_userDataPage = app_server + '/bankAccount/userDataPage';
export const bankAccount_saveData = app_server + '/bankAccount/saveData';
export const bankAccount_deleteData = app_server + '/bankAccount/deleteData';
export const bankAccount_getByAccount = app_server + '/bankAccount/getByAccount';
export const userBank_deleteUserBank = app_server + '/userBank/deleteUserBank';



export const enum_data_getTaxCatsEnum = app_server + '/enum_data/getTaxCatsEnum';
export const enum_data_getPMGetMoneyCatsEnum = app_server + '/enum_data/getPMGetMoneyCatsEnum';
export const enum_data_getPMCooperatesCatEnum = app_server + '/enum_data/getPMCooperatesCatEnum';

//数据统计
export const index_data_today = app_server + '/report/project_financial_statistical_today';//数据中心今日数据
export const index_data_total = app_server + '/report/project_financial_statistical_total';//总数据
export const index_data_list = app_server + '/report/project_financial_statistical_List';//总数据
export const index_data_contract_outline = app_server + '/report/contract_outline';//合同总纲

export const index_data_contract_outline_new = app_server + '/report/contract_outline_new';//合同总纲
export const index_data_contract_outline_info = app_server + '/report/contract_outline_info';//合同总纲详情
export const index_data_contract_outline_info_new = app_server + '/report/contract_outline_info_new';//合同总纲详情
export const index_data_save_remark = app_server + '/contractInfo/save_export_remarks';//合同总纲详情
export const index_data_contract_excel = app_server + '/report/contract_outline_excel';//合同列表导出
export const index_data_contract_excel_new = app_server + '/report/contract_outline_excel_new';//合同列表导出
export const customer_commission_export = app_server + '/sysAllowanceDetail/exportSysAllowanceByCM';//导出客户经理提成

export const internal_commission_by_customer_export = app_server + '/internalCommissionFile/internalCommissionByCustomer';//导出客服中心提成
export const internal_commission_by_project_export = app_server + '/internalCommissionFile/internalCommissionByProject';//导出工程管理中心提成

export const index_data_finance_statistics = app_server + '/report/finance_statistics';//财务列表
export const index_data_finance_statistics_excel = app_server + '/report/finance_statistics_excel';//财务列表导出
export const index_data_finance_statistics_summary_excel = app_server + '/report/finance_statistics_summary_excel';//财务总表-详情-汇总表导出接口
export const index_data_finance_info = app_server + '/report/finance_statistics_summary_info';//财务总表-详情
export const index_data_finance_info_supervision = app_server + '/report/finance_statistics_summary_info_supervision';//财务总表-详情
export const index_data_finance_detail = app_server + '/report/finance_statistics_detailed_info';//财务总表-详情-明细接口
export const apply_delSettlementPayInfo = app_server + '/apply/delSettlementPayInfo';//结算付款记录删除
export const report_finance_statistics_summary_information = app_server + '/report/finance_statistics_summary_information';//财务总表-详情-明细接口2
export const get_contract_attach = app_server + '/sealApply/getContractApplyAttach';//财务总表-详情-明细接口2
export const index_data_summary_calculate = app_server + '/financial_calc/summary_calculate';//项目视图汇总
export const manual_deduct_calcItem = app_server + '/financial_calc/manual_deduct_calcItem';//项目视图汇总
export const manualDeductionInfo = app_server + '/financePay/manualDeductionInfo';//项目视图汇总


export const index_data_finance_detail_excel = app_server + '/report/finance_statistics_detailed_info_excel';//财务总表-详情-明细导出接口
export const index_data_finance_remark = app_server + '/report/save_project_export_remark';//财务汇总表备注保存接口
export const finance_income_save_billing_balance = app_server + '/finance_income/save_billing_balance';//汇总表 补差额税费接口

export const getIntroducerCommissionPage = app_server + '/commission/getIntroducerCommissionPage';//提成列表
export const getIntroducerSearchByNameList = app_server + '/commission/getIntroducerSearchByNameList';//提成列表按姓名搜索下拉列表接口
export const exportIntroducerCommissionData = app_server + '/commission/exportIntroducerCommissionData';//提成列表导出数据
export const getIntroducerCommissionInfo = app_server + '/commission/getIntroducerCommissionInfo';//提成详情
export const getIntroducerTeamDetail = app_server + '/teamCommission/getIntroducerTeamDetail';//介绍人团队列表
export const getExceptionContractById = app_server + '/teamCommission/getExceptionContractById';//介绍人异常项目接口
export const getSysAllowanceAbortContractPage = app_server + '/sysAllowanceAbort/getSysAllowanceAbortContractPage';//不提成列表
export const getPMByNoCommissionList = app_server + '/sysAllowanceAbort/getPMByNoCommissionList';//不提成项目-项目总监搜索列表接口
export const exportSysAllowanceAbortContractPage = app_server + '/sysAllowanceAbort/exportSysAllowanceAbortContractPage';//导出不提成列表
export const getNoAbortContractPage = app_server + '/sysAllowanceAbort/getNoAbortContractPage';//不提成项目-新增查询项目接口
export const addSysAllowanceAbortProject = app_server + '/sysAllowanceAbort/addSysAllowanceAbortProject';//新增不提成项目接口
export const terminationProject = app_server + '/project/terminationContractInfo';//终止合同
export const terminationProjectList = app_server + '/report/terminationContractInfo';//终止合同列表接口
export const introducer_commission_export = app_server + '/commission/exportIntroducerCommissionProjectInfo';//导出客户经理提成





// ===== 获取数据相关
export const get_all_enum_data_map = app_server + '/data_cache/all_enum_data';
export const get_ex_enumData = app_server + '/report/getExEnumData'
export const get_projectDirDocStatusList = app_server + '/project/getProjectDirDocStatusCats'  //基础项资料
export const get_getEnumDataByLabel = app_server + '/enum_data/getEnumDataByLabel' //数据字典
export const get_financeManage = app_server + '/back_user/getFinanceManage'; //获取财务总监
export const getAllEnumData = app_server + '/report/getAllEnumData' // 数据字典


// ===== 子公司数据相关
export const subCom_save_data = app_server + '/subsidiaryCompany/save_data'; //增
export const subCom_del = app_server + '/subsidiaryCompany/delById'; //删
export const subCom_update = app_server + '/subsidiaryCompany/updateById'; //改
export const subCom_getPages = app_server + '/subsidiaryCompany/getPages'; //查
export const get_all_company = app_server + '/subsidiaryCompany/getAll';
export const subCom_findById = app_server + '/subsidiaryCompany/findById';
export const subCom_subCom_add_required = app_server + '/subsidiaryCompany/addSubComRequired';

// 保存子公司银行
export const subCom_saveBankData = app_server + '/subsidiaryCompany/saveBankData';
export const subCom_getCompanyBankPage = app_server + '/subsidiaryCompany/getCompanyBankPage';
export const subCom_getBankAccountByAccount = app_server + '/subsidiaryCompany/getBankAccountByAccount'; //获取单个
export const subCom_getPageBankAccountByAccount = app_server + '/subsidiaryCompany/getPageBankAccountByAccount';  //获取带分页
export const subCom_deleteBank = app_server + '/subsidiaryCompany/deleteBank';

// 项目管理相关
export const project_save = app_server + '/project/save';
export const project_send_comfirm = app_server + '/project/send_confirm';
export const project_get_draft_page = app_server + '/project/get_draft_page';
export const project_get_processed_page = app_server + '/project/getProcessedProjectPage';
export const project_get_valid_page = app_server + '/project/valid_page';
export const project_get_wait_page = app_server + '/project/get_wait_page';
export const project_get_duplicate_page = app_server + '/project/duplicate_page';
export const project_get_canCashProjectDetail = app_server + '/project/getCanCashProjectDetail';        //根据projectId 获取合同信息
export const project_get_working_page = app_server + '/project/working_page';
export const project_get_working_receivable_page = app_server + '/project/working_receivable_page';//已回款在建项目
export const project_get_finish_wait_page = app_server + '/project/finish_wait_page';
export const project_get_finish_page = app_server + '/project/finish_page';
export const project_manul_check_duplicate = app_server + '/project/manul_check_duplicate';
export const project_add_check_duplicate = app_server + '/project/add_check_duplicate';
export const project_auto_check_duplicate = app_server + '/project/auto_check_duplicate';
export const project_query_list = app_server + '/project/searchProjectList'; //项目管理-查询
export const project_revised = app_server + '/project/revisedProject';//勘误
export const new_project_save = app_server + '/project/saveProject';
export const attachRelevanceProjectPreparation = app_server + '/project/attachRelevanceProjectPreparation';
export const new_project_submit = app_server + '/project/submitProject';

export const project_contract_index = app_server + '/project/contract_index';

export const project_confirm_status = app_server + '/project/confirm_status';
export const project_finish_status = app_server + '/project/finish_status';
export const project_finish_audit = app_server + '/project/finishAudit';
export const project_delById = app_server + '/project/delById';
export const prodetailedinfo_addInfo = app_server + '/prodetailedinfo/addInfo';
export const prodetailedinfo_findByProId = app_server + '/prodetailedinfo/findByProId';
export const prodetailedinfo_fileList = app_server + '/prodetailedinfo/findByProIdAndType';
export const prodetailedinfo_findById = app_server + '/prodetailedinfo/findById';
export const prodetailedinfo_delById = app_server + '/prodetailedinfo/delById';
export const project_findById = app_server + '/project/findById';
export const project_findByBizItemId = app_server + '/project/findByBizItemId';
export const update_project_info = app_server + '/project/updateProjectInfo';
export const project_loss_findByBizItemId = app_server + '/project/findLoseByBizItemId';
export const project_updateById = app_server + '/project/updateById';
export const project_Lightspot_list = app_server + '/projectLightspot/getProjectLightspotByProjectId';//获取修改工程亮/难点的历史记录
export const project_Lightspot_update = app_server + '/projectLightspot/updateLatestByProjectId';//获取修改工程亮/难点的历史记录
export const project_getProjectScheduleInfo = app_server + '/project/getProjectScheduleInfo';//项目进度详情

//伤亡报告
export const casualtyReport_getAllPage = app_server + '/casualtyReport/getAllPage'; //伤亡报告列表
export const casualtyReport_getProject = app_server + '/project/toCasualtyApply'; //伤亡报告列表
export const getCasualtyApplyInfo = app_server + '/casualtyReport/getCasualtyApplyInfo'; //伤亡报告列表
export const project_getCasualtyReportPro = app_server + '/project/getCasualtyReportPro'; //选择项目 
export const casualtyReport_addCasualtyReport = app_server + '/casualtyReport/addCasualtyReport'; //新增伤亡事故
export const casualtyReport_doAudit = app_server + '/casualtyReport/reviewCasualtyReport'; //审核
export const casualtyReport_updateCasualtyRepor = app_server + '/casualtyReport/updateCasualtyReport'; //更新伤亡事故
export const casualtyReport_addInsuranceClaim = app_server + '/insuranceClaim/addInsuranceClaim'; //新增理赔
export const casualtyReport_getPMCasualtyReport = app_server + '/casualtyReport/getPMCasualtyReport'; //cd/cm视角查看伤亡事故
export const casualtyReport_agree = app_server + '/casualtyReport/agreeCasualtyApply'; //审核同意
export const casualtyReport_disagree = app_server + '/casualtyReport/disagreeCasualtyApply'; //审核不同意
export const casualtyReport_return = app_server + '/casualtyReport/returnCasualtyApply'; //审核退回
export const casualtyReport_change = app_server + '/casualtyReport/changeCasualtyApply'; //审核转交
export const casualtyReport_deal = app_server + '/casualtyReport/dealCasualtyApply'; //完成处理
export const casualtyReport_delete = app_server + '/casualtyReport/deleteCasualtyApply'; //删除
export const casualtyReport_saveCasualtyReport = app_server + '/casualtyReport/saveCasualtyReport'; //编辑
export const casualtyReport_getInsurancePage = app_server + '/casualtyReport/getInsurancePage'; //理赔 - 获取保险列表 
export const casualtyReport_getInsuranceClaimByProjectId = app_server + '/casualtyReport/getInsuranceClaimByProjectId'; //工程详情页 - 根据项目id获取理赔信息
export const insurance_getPreviousInfo = app_server + '/insurance/getPreviousInfo'; //添加保险 - 数据回显

export const get_enum_data_phase = app_server + '/enum_data/getProjectPhase';

export const casualtyReport_restartCasualtyApply = app_server + '/casualtyReport/restartCasualtyApply'; //事故管理 - 重启流程
export const casualtyReport_deleteInsuranceClaim = app_server + '/casualtyReport/deleteInsuranceClaim'; //事故详情 - 删除理赔数据

//在跟项目丢单管理
export const project_lose_apply = app_server + '/project/lose_order_apply';//丢单申请及审核
export const project_follow_type = app_server + '/project_follow_type';//丢单申请及审核
export const project_lose_order_report = app_server + '/project/lose_order_report';//丢单申请及审核

export const processLog_findById = app_server + '/processlog/findById';
export const processLog_updateById = app_server + '/processlog/updateById';
export const processLog_delById = app_server + '/processlog/delById';
export const processLog_getAll = app_server + '/processlog/getAll';
export const processLog_addInfo = app_server + '/processlog/addInfo';
export const update_project_status = app_server + '/report/getUpdateProjectStatus';   //编辑项目实际开工-竣工日期

export const getWithProjectPhase = app_server + '/processlog/getWithProjectPhase';
export const getProcessLogEcho = app_server + '/processlog/getProcessLogEcho';
export const getBuildingProjectPhase = app_server + '/processlog/getBuildingProjectPhase';

export const getProjectCertifiedPersonnel = app_server + '/certificateApply/getProjectCertifiedPersonnel'; //持证人员
export const getSealApplyListByProject = app_server + '/sealApply/getSealApplyListByProject'; //用印资料

export const project_restartProjectLoseApply = app_server + '/project/restartProjectLoseApply';//丢单-重启流程
export const project_deleteLoseByBizItemId = app_server + '/project/deleteLoseByBizItemId';//丢单-删除流程

//项目变更
export const projct_change_choose = app_server + '/project/project_change_working_page';//选择需要变更的项目
export const projct_change_add = app_server + '/project/project_change_info';//新增/编辑/详情变更合同
export const contract_find_change_type = app_server + '/enum_data/find_change_type';//合同变更类型
export const contract_getMainContractNo = app_server + '/contractInfo/getMainContractNo';//自动生成合同编号
export const contract_save_draft = app_server + '/contractInfo/second_save_draft';//保存变更合同
export const contract_do_audit = app_server + '/contractInfo/do_audit';//审核合同
export const projct_change_CMlist = app_server + '/contractInfo/getChildrenPages';//变更项目列表-客户经理
export const projct_change_commonList = app_server + '/contractInfo/children_valid_page';//变更项目列表-其他角色
export const contract_getChageContractAuditStatus = app_server + '/contractInfo/getChageContractAuditStatus';//总审核状态下拉框
export const contract_change_delete = app_server + '/contractInfo/delChangeContract';//删除
export const contract_getChageContractAuditStatusAndOwn = app_server + '/contractInfo/getChageContractAuditStatusAndOwn';//我的审核下拉框

//客户意向
export const addCustomerIntention = app_server + '/customerIntention/addCustomerIntention';//新增客户意向接口
export const getCustomerIntentionPage = app_server + '/customerIntention/getCustomerIntentionPage';//客户意向列表
export const getCustomerIntentionInfoById = app_server + '/customerIntention/getCustomerIntentionInfoById';//客户意向详情
export const customerIntention_sys_cm = app_server + '/data/sys_cm';//客户经理下拉列表和分配列表接口
export const getIntentionLinkmanList = app_server + '/customerIntention/getIntentionLinkmanList';//联系人
export const customerIntention_assigningCm = app_server + '/customerIntention/assigningCm';//分配客户经理接口
export const customerIntention_assigningPm = app_server + '/customerIntention/assigningPm';//分配项目总接口





//费用申请相关
export const fee_application = app_server + '/costapply/addCostApply';
export const fee_history = app_server + '/costapply/getPages';
export const fee_edit_find = app_server + '/costapply/findById';
export const fee_edit_update = app_server + '/costapply/updateById';
// 工程分类
export const engineerList = app_server + '/engineerCat/engineerCatData';
export const engineer_updateById = app_server + '/engineerCat/updateById';
export const engineer_delById = app_server + '/engineerCat/delById';
export const engineer_addEngineerCat = app_server + '/engineerCat/addEngineerCat';
// 省市区
export const districtData = app_server + "/districtData/list"
export const district_updateById = app_server + "/districtData/updateById"
export const district_delById = app_server + "/districtData/delById"
export const district_insert = app_server + "/districtData/insert"

//获取项目下拉框数据相关
export const get_all_project = app_server + '/project/getAll';

//上传文件相关
export const upload_file = app_server + '/upload/ossupLoadImage';
export const download_file = app_server + '/download/ossupLoadImage';

export const receivable_upload_file = app_server + '/finance_income/uploadExcelReceivable_check';//批量上传流水检测
export const receivable_upload_file_save = app_server + '/finance_income/uploadExcelReceivable_save';//批量上传流水检测


// 由我写的上传文件, 上面的 upload_file / download_file 会定期删除. 
export const common_upload_image = app_server + '/common/upload_image';
export const common_get_attach_list = app_server + '/common/get_attach_list';
export const common_delete_attach = app_server + '/common/delete_attach';

export const file_get_attach_list = app_server + '/attach/get_attach_list';
export const file_delete_attach = app_server + '/attach/delete_attach';


//客户总监相关
// export const   cusManager_getTeamPages = app_server+'/cusManager/getSubTeamPages';
// export const   cusManager_delPMSubTeamById = app_server+'/cusManager/delPMSubTeamById';

export const cusManager_getPersonalInfo = app_server + '/cusManager/getPersonalInfo';
export const cusManager_addPersonalInfo = app_server + '/cusManager/savePersonalInfo';
export const cusManager_updateFinance = app_server + '/cusManager/updateFinanceIncomeById'; //发送审核
export const cusManager_findFIById = app_server + '/cusManager/findFIById';              //获取信息
export const cusManager_getFinancePages = app_server + '/cusManager/getFinanceIncomePages';   //获取列表
export const cusManager_getContractPages = app_server + '/cusManager/getContractPageByNailLinkPer';  //获取合同列表

export const cusManager_getPMPages = app_server + '/cusManager/getPMPageByNailLinkPer';  //获取项目总监
export const cusManager_blacklistsStatus = app_server + '/proManager/blacklistsStatus';  //项目总监移入/移出黑名单
export const cusManager_getPMBlacklistsPages = app_server + '/proManager/getPMBlacklistsPages';  //项目总监黑名单列表



//奖惩列表相关
export const rewardsPunish_page_data = app_server + '/rewardsPunish/getRPPages';
export const rewardsPunish_findRPById = app_server + '/rewardsPunish/findRPById';
export const rewardsPunish_delRPById = app_server + '/rewardsPunish/delRPById';



//项目总监相关
export const proManager_updatePersonalInfo = app_server + '/proManager/updatePersonalInfo';
export const proManager_getPersonalInfo = app_server + '/proManager/getPersonalInfo';
export const proManager_getProjectManagerPages = app_server + '/proManager/getPMPages';
export const proManager_getAuditStatusCode = app_server + '/proManager/getAuditStatusCode';//列表审核状态
export const proManager_getPMPagesByBmAudit = app_server + '/proManager/getPMPagesByBmAudit';//商务经理获取商务部项目总监列表审核状态
export const getPMPagesByManage = app_server + '/proManager/getPMPagesByManage';
export const proManager_getPMPagesByCmDirectorAudit = app_server + '/proManager/getPMPagesByCmDirectorAudit';//客户经理获取客户部项目总监列表审核状态
export const proManager_getProjectManagerPages4UpdateApply = app_server + '/proManager/getPMPages4UpdateApply';
export const proManager_getUpdateApplayProcess = app_server + '/proManager/getUpdateApplayProcess';
export const pm_page_data = app_server + '/proManager/getPageData';          //待合并
export const get_pm_page_data = app_server + '/proManager/getPmPageData';

export const proManager_projectManager_save = app_server + '/proManager/addProjectManager';
export const proManager_projectManager_update = app_server + '/proManager/updateProjectManager';
export const proManager_auditProjectManager = app_server + '/proManager/auditProjectManager';//商务经理审核项目总监接口
export const proManager_updateProjectManagerBusiness = app_server + '/proManager/updateProjectManagerBusiness';
export const approval_add_update = app_server + '/projectManager/addOrUpdate';

//export const   proManager_projectManager_toggleStatusPMById = app_server+'/proManager/toggleStatusPMById';
export const proManager_projectManagerStatus_change = app_server + '/proManager/updateStatusById';
export const proManager_projectManager_findPMById = app_server + '/proManager/findPMById';              //获取项目总监编辑信息
export const proManager_projectManager_findPMInfoById = app_server + '/proManager/findPMInfoById';      //获取项目总监只读信息
export const proManager_projectManager_getMoreInfo = app_server + '/proManager/getMoreInfo';
export const proManager_projectManager_updateMoreInfo = app_server + '/proManager/updateMoreInfo';
export const proManager_projectManager_updateApply = app_server + '/proManager/updateApply'; //申请修改
export const proManager_projectManager_updateApplayAudit = app_server + '/proManager/updateApplyAudit'; //申请修改审核
export const proManager_projectManager_deleteDraftPMById = app_server + '/proManager/deleteDraftPMById';//删除草稿状态项目总监信息
export const proManager_partyInfoFullPre = app_server + '/proManager/partyInfoFullPre';  //获取项目总监
export const proManager_partyInfoFullCom = app_server + '/proManager/partyInfoFullCom';  //获取项目总监
export const proManager_findByPhone = app_server + '/proManager/findByPhone';
export const proManager_saveBankData = app_server + '/proManager/saveBankData';
export const financePay_leagueDepositPage = app_server + '/financePay/leagueDepositPage'; //项目总监联盟保证金明细列表
export const financePay_editLeagueDeposit = app_server + '/financePay/editLeagueDeposit'; //修改联盟保证金明细
export const financePay_statisticalAdvanceTaxList = app_server + '/financePay/statisticalAdvanceTaxList'; //项目视图详情退预缴接口
export const financePay_getAdvanceTaxInfo = app_server + '/advanceTax/getAdvanceTaxInfo'; //项目视图查看退预缴详情接口
export const proManager_saveOrUpdateSales = app_server + '/salePerformance/saveOrUpdateSalePerformance'; //销售业绩新增或修改
export const proManager_getSalesList = app_server + '/salePerformance/getSalePerformance'; //根据pmId 以及ids来查询销售业绩
export const proManager_deleteSalesList = app_server + '/salePerformance/deleteSalePerformance'; //删除销售业绩
export const addProjectManagerOfSimple = app_server + '/proManager/addProjectManagerOfSimple';//新增临时项目总监接口
export const proManager_getPMBySearchCondition = app_server + '/proManager/getPMBySearchCondition';//搜索项目总监
export const proManager_addProjectManagerIssue = app_server + '/projectManagerIssue/addProjectManagerIssue';//项目总监详情新增/编辑异常信息
export const proManager_deletePMIssueById = app_server + '/projectManagerIssue/deletePMIssueById';//项目总监详情删除异常信息接口
export const proManager_cancelMonitorById = app_server + '/projectManagerIssue/cancelMonitorById';//项目总详情解除异常监控接口
export const proManager_saveOrUpdateByTemp = app_server + '/interview/saveOrUpdateByTemp';//项目总监详情页新增/编辑访谈记录接口
export const proManager_getPmFreezePage = app_server + '/proManager/getPmFreezePage';//项目总监冻结列表
export const updatePmFreezeAndUnfreeze = app_server + '/proManager/updatePmFreezeAndUnfreeze';//解冻/冻结项目总监接口





//项目总监访谈
export const proManager_interview_page_data = app_server + '/interview/page_data';//列表
export const proManager_interview_findbyId = app_server + '/interview/findbyId';//详情
export const proManager_interview_leaderEvaluation = app_server + '/interview/leaderEvaluation';//客户总监评价
export const proManager_findProjectManagerByCm = app_server + '/proManager/findProjectManagerByCm';//项目总监列表
export const proManager_interview_save = app_server + '/interview/saveOrUpdate';//新增访谈保存
export const proManager_interview_submit = app_server + '/interview/submit';//新增访谈提交
export const proManager_interview_findbyPmId = app_server + '/interview/findbyPmId';//项目总监编辑过的信息

export const proManager_interview_getDataByPM = app_server + '/interview/getDataByPM';//项目总监列表访谈记录

export const proManager_getProjectManagerInfo = app_server + '/proManager/getProjectManagerInfo';//获取项目经理信息

export const proManager_getProjectByPmIdAndStatus = app_server + '/proManager/getProjectByPmIdAndStatus';// 查看项目总监正在施工和已完成的项目



// === 项目总监关系管理
export const introducer_create_new = app_server + '/introducer/create_new';
export const introducer_add_introducer = app_server + '/introducer/addIntroducer';
export const introducer_update_by_id = app_server + '/introducer/updateById';
export const introducer_find_by_id = app_server + '/introducer/findById';
export const introducer_findInfoById = app_server + '/introducer/findInfoById';
export const introducer_findIntroducerBriefInfoById = app_server + '/introducer/findIntroducerBriefInfoById';
export const introducer_findRelationById = app_server + '/introducer/findRelationById';
export const introducer_findRelationByIdForCommission = app_server + '/introducer/findRelationByIdForCommission';
export const introducer_getPage = app_server + '/introducer/getIntroducerPages';
export const introducer_findTeamOneById = app_server + '/introducer/findTeamOneById';//主团队信息
export const introducer_findTeamTwoById = app_server + '/introducer/findTeamTwoById';//次团队信息
export const introducer_delete_by_id = app_server + '/introducer/delById';
export const introducer_page_data = app_server + '/introducer/page_data';
export const introducer_getAllUserByIntroducer = app_server + '/introducer/getAllUserByIntroducer';   //获取未创建介绍人的用户

// === 项目总监团队管理
export const pMSubTeam_save = app_server + '/pMSubTeam/savePMSubTeam';            //添加介绍人
export const pMSubTeam_get_page = app_server + '/pMSubTeam/getPMSubTeamPages';    //获取分页数据
export const pMSubTeam_findById = app_server + '/pMSubTeam/findInfoById';         //根据id查询
export const pMSubTeam_delById = app_server + '/pMSubTeam/delById';               //删除


// export const pm_page_data = app_server+'/proManager/getPMPages';
// export const pm_page_data = app_server+'/cusManager/getPMPages';

// === 所属公司
export const company_getCompanyPages = app_server + '/company/getCompanyPages';
export const company_findById = app_server + '/company/findById';
export const company_findCompanyInfoById = app_server + '/company/findCompanyInfoById';
export const company_addCompany = app_server + '/company/addCompany';
export const company_updateById = app_server + '/company/updateById';
export const company_delById = app_server + '/company/delById';
export const company_page_data = app_server + '/company/page_data';
export const company_getAll = app_server + '/company/getAll';




// === 客户
export const customer_page_data = app_server + '/customer/getPages';
export const customer_page_data_ui = app_server + '/customer/getPagesUI';
export const customer_findById = app_server + '/customer/findById';
export const customer_save = app_server + '/customer/save';
export const customer_save1 = app_server + '/customer/save1';
export const customer_delete_by_id = app_server + '/customer/delById';
export const customer_findByProjectId = app_server + '/customer/findByProjectId';
export const customer_shareholder = app_server + '/customer/insertOrUpdateOrDeleteCustomerShareholder';
export const insertOrUpdateCustomerMarket = app_server + '/customer/insertOrUpdateCustomerMarket';
export const customer_issue = app_server + '/customer/insertOrUpdateCustomerIssue';
export const customer_Contact = app_server + '/customer/insertOrUpdateCustomerContact';
export const deleteCustomerIssue = app_server + '/customer/deleteCustomerIssue';
export const deleteCustomerContact = app_server + '/customer/deleteCustomerContact';
export const deleteCustomerMarket = app_server + '/customer/deleteCustomerMarket';
export const getRegisterPlatformList = app_server + '/customer/getRegisterPlatformList';
export const addRegisterPlatform = app_server + '/customer/addRegisterPlatform';
export const getRegisterPlatformDetail = app_server + '/customer/getRegisterPlatformDetail';
export const updateRegisterPlatform = app_server + '/customer/updateRegisterPlatform';
export const customer_shiftBlack = app_server + '/customer/shiftBlacklist';
export const addRegisterPlatformReport = app_server + '/customer/addRegisterPlatformReport';
export const updateRegisterPlatformReport = app_server + '/customer/updateRegisterPlatformReport';
export const deleteRegisterPlatformReport = app_server + '/customer/deleteRegisterPlatformReport';




// ===合同
export const contractInfo_getContractPages = app_server + '/contractInfo/getContractPages';
export const contractInfo_getPages = app_server + '/contractInfo/getPages';
export const contractInfo_valid_page = app_server + '/contractInfo/valid_page';
export const contractInfo_all_ok_page = app_server + '/contractInfo/all_ok_page';//选择合同
export const contractInfo_all_ok_page_type = app_server + '/contractInfo/all_ok_page_type';//选择合同
export const contractInfo_updateById = app_server + '/contractInfo/updateById';
export const contractInfo_findById = app_server + '/contractInfo/findById';
export const contractInfo_delById = app_server + '/contractInfo/delById';
export const contractInfo_save_draft = app_server + '/contractInfo/save_draft';
export const contractInfo_do_audit = app_server + '/contractInfo/do_audit';

export const contractInfo_getAllMainContractionInfo = app_server + '/contractInfo/getAllMainContractionInfo';
export const contractInfo_toexamine = app_server + '/contractInfo/toexamine';
export const contractInfo_findByContractNo = app_server + '/contractInfo/findByContractNo';
export const contractInfo_getSonContractNo = app_server + '/contractInfo/getSonContractNo';
export const contractInfo_getMainContractNo = app_server + '/contractInfo/getMainContractNo';
export const contractInfo_update_operate = app_server + '/contractInfo/updateContractOperateData';
export const contractInfo_update_finance = app_server + '/contractInfo/updateContractFinanceData';


export const contractInfo_getInsuranceCats = app_server + '/contractInfo/getInsuranceCats';

export const contractInfo_upload_attach = app_server + '/contractInfo/upload_attach';
export const contractInfo_saveInvoiceAmount = app_server + '/contractInfo/saveInvoiceAmount';
export const contractInfo_getAuditStatus = app_server + '/contractInfo/getAuditStatus';
export const contractInfo_old_contractInfo = app_server + '/contractInfo/OldContractInfo';//老合同
export const finance_income_check_effective = app_server + '/finance_income/check_project_effective';//客户经理认领合同判断是否错误
export const contractInfo_upload_files = app_server + '/contractInfo/uploadContractInfoByWorking';//在建项目上传合同附件
export const contractInfo_export_Excel = app_server + '/contractInfo/contractInfoExcel';//导出合同列表
export const contractInfo_get_taxCatValue = app_server + '/contractInfo/getTaxCatValue';//根据合同类型查询票种接口

export const projectDocDir_getProjectDocDirTitle = app_server + '/projectDocDir/getProjectDocDirTitle';//根据合同类型查询票种接口

export const contractInfo_agreeContract = app_server + '/contractInfo/agreeContract';//合同审批-同意
export const contractInfo_disagreeContract = app_server + '/contractInfo/disagreeContract';//合同审批-拒绝
export const contractInfo_returnContract = app_server + '/contractInfo/returnContract';//合同审批-退回
export const contractInfo_saveContract = app_server + '/contractInfo/saveContract';//合同审批-保存
export const contractInfo_submitContract = app_server + '/contractInfo/submitContract';//合同审批-提交
export const contractInfo_changeContract = app_server + '/contractInfo/changeContract';//合同审批-转交
export const contractInfo_secondSaveContract = app_server + '/contractInfo/secondSaveContract';//变更合同-保存
export const contractInfo_secondSubmitContract = app_server + '/contractInfo/secondSubmitContract';//变更合同-提交



//保险相关
export const insurance_saveContractInsurance = app_server + '/insurance/saveContractInsurance';//添加保险
export const insurance_list = app_server + '/insurance/getContractInsurancePage';//保险列表
export const insurance_get_CID_Page = app_server + '/project/getCIDPage';//新增保险记录/合同列表
export const insurance_get_excel = app_server + '/insurance/contractInsuranceExcel';//保险列表数据excel
export const insurance_delete = app_server + '/insurance/editInsuranceStatus';//删除保险
export const insurance_purchaseContractInsurance = app_server + '/insurance/purchaseContractInsurance';//bxzy购买保险
export const insurance_edit = app_server + '/insurance/editInsuranceInfo';//修改保险
export const insurance_getInsuranceCategoryOps = app_server + '/insurance/getInsuranceCategoryOps';//添加保险 - 获取保险种类
export const insurance_getInsurancePurchaseWayOps = app_server + '/insurance/getInsurancePurchaseWayOps';//添加保险 - 获取保险种类购买方式
export const insurance_getInsuranceCategoryRateOps = app_server + '/insurance/getInsuranceCategoryRateOps';//添加保险 - 获取保险种类费率


export const insurance_getProjectInfo = app_server + '/insurance/getProjectInfo';//添加保险 - 获取项目详情
export const insurance_getContractInsuranceDetail = app_server + '/insurance/getContractInsuranceDetail';//获取保险详情
export const insurance_agreeInsurance = app_server + '/insurance/agreeInsurance';//保险审批 - 同意
export const insurance_disagreeInsurance = app_server + '/insurance/disagreeInsurance';//保险审批 - 拒绝
export const insurance_returnInsurance = app_server + '/insurance/returnInsurance';//保险审批 - 退回
export const insurance_changeInsurance = app_server + '/insurance/changeInsurance';//保险审批 - 转交
// export const  insurance_purchaseContractInsurance = app_server + '/insurance/purchaseContractInsurance';//购买保险
export const insurance_editInsuranceStatus = app_server + '/insurance/editInsuranceStatus';//删除保险
export const getInsuranceInfoByProjectId = app_server + '/insurance/getInsuranceInfoByProjectId';//工程详情页 - 根据工程id获取保险信息
export const insurance_addInsurance = app_server + '/insurance/addInsurance';//项目详情页 - 添加保险

export const insurance_restartInsuranceApply = app_server + '/insurance/restartInsuranceApply';//重启流程
export const insurance_deleteInsurance = app_server + '/insurance/deleteInsurance';//删除保单
export const insurance_deleteContractInsurance = app_server + '/insurance/deleteContractInsurance';//删除流程



//在建项目
export const project_working_project_page = app_server + '/project/working_project_page'; //在建项目列表
// 完工
export const submitSettlementApply = app_server + '/apply/submitSettlementApply'; //完工结算申请提交接口
export const getSettlementApplyPage = app_server + '/apply/getSettlementApplyPage'; //完工结算列表
export const settlementApplyInfo = app_server + '/apply/settlementApplyInfo'; //完工结算详情
export const settlementApply_audit = app_server + '/apply/auditSettlementApply'; //完工结算审批通过
export const settlementApply_change = app_server + '/apply/changeSettlementApply'; //完工结算转交
export const settlementApply_return = app_server + '/apply/returnSettlementApply'; //完工结算退回
export const settlementApply_disAgree = app_server + '/apply/disAgreeSettlementApply'; //完工结算拒绝
export const settlementApply_complete = app_server + '/apply/completeSettlementApply'; //完工结算处理
export const settlementPay = app_server + '/apply/settlementPay'; //完工结算付款
export const uploadSettlementApply = app_server + '/apply/uploadSettlementApply'; //完工结算上传凭证


//客户总监相关
export const cmDirector_projectManager_findPMById = app_server + '/cmDirector/findPMById';
export const cmDirector_projectManager_doAudit = app_server + '/cmDirector/projectManager_doAudit';
export const cmDirector_introducer_doAudit = app_server + '/cmDirector/introducer_doAudit';
export const cmDirector_project_update_cm = app_server + '/cmDirector/project_update_cm';//更换项目所属客户经理



// ===流水相关
export const finance_income_save_draft = app_server + '/finance_income/save_draft'; //新增收款流水草稿
export const finance_income_get_page = app_server + '/finance_income/get_page'; //查询收款流水列表
export const finance_income_get_history_page = app_server + '/finance_income/get_history_page'; //查询收款流水列表
export const finance_income_find_by_id = app_server + '/finance_income/find_by_id'; //查询收款流水列表
export const finance_income_send_confirm = app_server + '/finance_income/send_confirm';
export const finance_income_audit_ok_by_cm = app_server + '/finance_income/audit_ok_by_cm';
export const finance_income_audit_ok_by_fm = app_server + '/finance_income/audit_ok_by_fm';
export const finance_income_do_audit = app_server + '/finance_income/do_audit';
export const finance_income_check_duplicate = app_server + '/finance_income/check_duplicate_receivable'; //收款流水重复数据对比
export const finance_income_delete_by_id = app_server + '/finance_income/delete_by_id'; //收款流水删除
export const finance_computing_page_number = app_server + '/financeStat/computing_page_number';

export const finance_get_auditStatus = app_server + '/finance_income/getAuditStatus'; //获取状态


export const finance_updateFIById = app_server + '/finance/updateFIById'; //编辑收款流水
export const finance_findFIById = app_server + '/finance/findFIById'; //获取收款流水信息
export const finance_delFIById = app_server + '/finance/delFIById'; //删除收款流水
export const finance_sendAudit = app_server + '/finance/doAuditTO_DO'; //发送审核
export const getCompanyName = app_server + '/customer/getPages';
export const finance_add_markContents = app_server + '/finance_income/add_income_markContent'; //新增标注

export const finance_income_relate_apply = app_server + '/finance_income/relate_apply'; //认领收款流水关联代付单
export const contractInfo_claim_payment = app_server + '/contractInfo/claim_payment'; //认领收款流水合同列表
export const income_data_all_cm = app_server + '/data/all_cm'; //收款流水获取认领人选项


// ===财务经理相关
export const finManager_getPages = app_server + '/finManager/getFinanceIncomePages'; //查询收款流水列表
export const finManager_findFIById = app_server + '/finManager/findFIById'; //获取流水信息
export const finManager_doAuditById = app_server + '/finManager/doAuditById'; //发送审核
export const finManager_xm_company_bank = app_server + '/finance_income/xm_company_bank'; //获取新美银行
export const finance_income_printing = app_server + '/finance_income/income_printing'; //打印项目回款确认单 
export const finance_income__printing_prompt = app_server + '/finance_income/income_printing_prompt'; //收款流水全部打印提示 

// ===财务总监相关
export const finDirector_getPages = app_server + '/finDirector/getFinanceIncomePages'; //查询收款流水列表
export const finDirector_findFIById = app_server + '/finDirector/findFIById'; //查询收款流水列表
export const finDirector_doAuditById = app_server + '/finDirector/doAuditById'; //查询收款流水列表
export const finDirector_project_visible = app_server + '/financeStat/project/visible'; //项目视图 显示/隐藏 项目总监是否可见
export const financeStat_project_settlement = app_server + '/financeStat/project/settlement'; //项目视图 结算 
export const finance_income_check_billing_balance = app_server + '/finance_income/check_billing_balance'; //项目视图列表判断是否结算 
export const getMaterialTicketList = app_server + '/financePay/materialTicketList'; //项目视图详情进项材料票按供应商
export const getMaterialTicketPage = app_server + '/materialTicketInfo/getMaterialTicketPage'; //项目视图详情进项材料票按供应商
export const getSupplierPageByProjectId = app_server + '/payRoll/getSupplierPageByProjectId'; //项目视图详情进项材料票关联供应商列表
export const relevanceSupplier = app_server + '/materialTicket/relevanceSupplier'; //项目视图详情进项材料票关联供应商列表
export const materialTicketLaborPage = app_server + '/financePay/materialTicketLaborPage'; //项目视图详情进项票-劳务发票接口


//丢单
export const project_lose_order_page = app_server + '/project/lose_order_page'; //项目视图 结算 
export const financePay_salesTicketManualList = app_server + '/financePay/salesTicketManualList'  //项目视图 销项票
export const project_lose_order_pages = app_server + '/project/lose_order_pages'  //丢单列表页
export const project_lose_order_update = app_server + '/project/lose_order_update'  //丢单申请
export const project_lose_order_bizItemId = app_server + '/project/findLoseByBizItemId'  //丢单详情
export const submit_change_project_lose = app_server + '/project/changeProject_lose'  //转交
export const submit_disagree_project_lose = app_server + '/project/disagreeProject_lose'  //拒绝
export const submit_agree_project_lose = app_server + '/project/agreeProject_lose'  //同意
export const submit_return_project_lose = app_server + '/project/returnProject_lose'  //退回
export const submit_complete_project_lose = app_server + '/project/completeProject_lose'  //完成处理
export const delete_lose_by_bizItemId = app_server + '/project/deleteLoseByBizItemId'  //删除丢单项目


// ===boss相关
export const boss_getPages = app_server + '/boss/getFinanceIncomePages'; //查询收款流水列表
export const boss_findFIById = app_server + '/boss/findFIById'; //查询收款流水列表
export const boss_doAuditById = app_server + '/boss/doAuditById'; //查询收款流水列表

// 删除项目附件
export const processlog_updateEnclosure = app_server + '/processlog/updateEnclosure';
export const ProDetailedInfo_updateEnclosure = app_server + '/prodetailedinfo/updateEnclosure';


// 银行信息
export const bankInfo_page_data = app_server + '/bankInfo/page_data';
export const bankInfo_save = app_server + '/bankInfo/save';
export const bankInfo_findById = app_server + '/bankInfo/findById';
export const bankInfo_findByName = app_server + '/bankInfo/findByName';
export const bankInfo_delById = app_server + '/bankInfo/delete';
export const bankInfo_updateById = app_server + '/bankInfo/updateById';
export const bankInfo_findByType = app_server + '/bankInfo/findByType';

export const bankInfo_get_bank_list = app_server + '/bankInfo/get_bank_list';
export const bankInfo_get_branch_list_by_parent = app_server + '/bankInfo/get_branch_list_by_parent';
export const bankInfo_save_bank_or_branch = app_server + '/bankInfo/save_bank_or_branch';


// === 业务介绍人
export const business_introducer_page_data = app_server + '/businessIntroducer/page_data';
export const business_introducer_find_by_id = app_server + '/businessIntroducer/find_by_id';
export const business_introducer_save = app_server + '/businessIntroducer/save';


//民族
export const enum_data_getEnumDataByType = app_server + '/enum_data/getEnumDataByType'


// 运营中心
export const operationCenter_page_data = app_server + '/operationCenter/page_data';
export const operationCenter_save = app_server + '/operationCenter/save';
export const operationCenter_findById = app_server + '/operationCenter/findById';
export const operationCenter_findBySubCompanyId = app_server + '/operationCenter/findBySubCompanyId'; //不分页
export const operationCenter_delById = app_server + '/operationCenter/delById';
export const operationCenter_updateById = app_server + '/operationCenter/updateById';
export const getProjectPhase = app_server + '/project/getProjectPhase';
export const getProcess = app_server + '/flow/getFlowProcessProgressOps';
export const getDataByLabel = app_server + '/enum_data/getEnumDataByLabel';
export const getLevelByLabel = app_server + '/enum_data/getLevelEnumData';
export const getDataByLabelList = app_server + '/proManager/getPMPagesByExecutive';
export const get_guarantee_list = app_server + '/guaranteeLetter/getGuaranteeLetterPage';
export const get_agency_ops = app_server + '/guaranteeLetter/getGuaranteeAgencyOps';
export const get_guarantee_project_choose = app_server + '/project/getGuaranteeProjectChooseList';
export const get_guarantee_letter_apply = app_server + '/guaranteeLetter/queryGuaranteeLetterApply';
export const get_project_info = app_server + '/project/getChooseProjectBaseInfo';
export const save_guarantee = app_server + '/guaranteeLetter/saveGuaranteeLetterApply';
export const submit_guarantee = app_server + '/guaranteeLetter/submitGuaranteeLetterApply';
export const agree_guarantee = app_server + '/guaranteeLetter/agreeGuaranteeLetterApply';
export const disagree_guarantee = app_server + '/guaranteeLetter/disagreeGuaranteeLetterApply';
export const return_flowt_guarantee = app_server + '/guaranteeLetter/returnFlowGuaranteeLetterApply';
export const change_guarantee = app_server + '/guaranteeLetter/changeGuaranteeLetterApply';
export const del_guarantee = app_server + '/guaranteeLetter/delGuaranteeLetterApply';
export const buy_guarantee = app_server + '/guaranteeLetter/buyGuaranteeLetter';
export const add_guarantee = app_server + '/guaranteeLetter/addGuaranteeAgency';
export const add_qualification = app_server + '/enterpriseQualification/saveEnterpriseQualification';
export const get_qualification_list = app_server + '/enterpriseQualification/getEnterpriseQualificationPage';
export const delete_qualification = app_server + '/enterpriseQualification/deleteEnterpriseQualification';
export const get_project_list = app_server + '/project/getProjectPage';
export const submit_agree_project = app_server + '/project/agreeProject';
export const submit_disagree_project = app_server + '/project/disagreeProject';
export const submit_change_project = app_server + '/project/changeProject';
export const submit_return_project = app_server + '/project/returnProject';
export const submit_complete_project = app_server + '/project/completeProject';
export const flow_getFlowDealProcessOps = app_server + '/flow/getFlowDealProcessOps';
export const followPro_addProjectInfo = app_server + '/processlog/addProjectInfo';
export const del_buy_guarantee = app_server + '/guaranteeLetter/delBuyGuaranteeLetter';
export const del_process_guarantee = app_server + '/guaranteeLetter/delGuaranteeLetterProcess';
export const reset_process_guarantee = app_server + '/guaranteeLetter/resetGuaranteeLetterProcess';
export const reset_process_project = app_server + '/project/resetDraftProjectProcess';
export const all_customerIntention_data = app_server + '/customerIntention/getAllEnumData'



//消息
export const message_type = app_server + '/xmMessage/getCats'; //获取消息类型
export const message_list = app_server + '/xmMessage/getPages4MyReceive'; //获取消息内容
export const message_unread = app_server + '/xmMessage/getUnreadCount'; //获取未读消息数量
export const message_remarkRead = app_server + '/xmMessage/read'; //标记消息已读
export const message_unreadMsgCount = app_server + '/xmMessage/unreadMsgCount'; //获取代办数量
export const message_unreadMsgPage = app_server + '/xmMessage/unreadMsgPage'; //获取代办列表
export const message_open_close = app_server + '/back_user/wxUnreadMsgOpenOrClose'; //待办提醒关闭
export const message_unreadCopyMsgPage = app_server + '/xmMessage/unreadCopyMsgPage'; //获取抄送消息列表
export const message_unreadCopyMsgCount = app_server + '/xmMessage/unreadCopyMsgCount'; //获取抄送消息数量



// 危险的后门操作
export const danger_reset_contract_audit_status = app_server + '/danger/reset_contract_audit_status';
export const danger_reset_apply_data_audit_status = app_server + '/danger/reset_apply_data_audit_status';
export const danger_resetFinanceIncomeAuditStatus = app_server + '/danger/resetFinanceIncomeAuditStatus';
export const danger_auditIncomeList = app_server + '/danger/auditIncomeList';

// 扣款
export const financePay_deductionsType = app_server + '/financePay/deductionsType';//扣款类型下拉框
export const financePay_saveData = app_server + '/financePay/saveData';
export const financePay_pageData = app_server + '/financePay/pageData';
export const financePay_deleteById = app_server + '/financePay/deleteById';

export const insurance_getProjectViewInsurancePage = app_server + '/insurance/getProjectViewInsurancePage'; //项目视图保险
export const financePay_manualList = app_server + '/financePay/manualList';                // 所有手动扣款项, 包括材料代付, 预付款
export const financePay_financeItem = app_server + '/financePay/findFinanceItem';
export const financePay_deduct_calcItem = app_server + '/financial_calc/manual_deduct_calcItem';
export const financePay_deduction_detail = app_server + '/financePay/manualDeductionInfoList';//手动扣款详情页
export const financePay_deduction_list = app_server + '/financePay/manualDeductionList';//手动扣款列表页
export const financePay_manualDeductionListExcel = app_server + '/financePay/manualDeductionListExcel';//手动扣款列表导出
export const financePay_uploadExcelFinancePay_check = app_server + '/financePay/uploadExcelFinancePay_check';//手动扣款批量导入
export const financePay_check_xmFinanceItem = app_server + '/financePay/check_xmFinanceItem';//重复对比
export const financePay_manualDeductionErrorDataExcel = app_server + '/financePay/manualDeductionErrorDataExcel';//导出错误数据
export const financePay_uploadExcelFinancePay_save = app_server + '/financePay/uploadExcelFinancePay_save';//确定导入
export const advanceTax_getAdvanceTaxProjectPage = app_server + '/advanceTax/getAdvanceTaxProjectPage';//手动扣款选择退预缴项目接口
export const advanceTax_saveProjectAdvanceTax = app_server + '/advanceTax/saveProjectAdvanceTax';//手动扣款新增退预缴数据接口
export const advanceTax_getAdvanceTaxList = app_server + '/advanceTax/getAdvanceTaxList';//手动扣款查看预缴税费明细接口

// 预缴税费
export const getAdvanceTaxApplyPage = app_server + '/advanceTaxApply/getAdvanceTaxApplyPage';//退预缴申请列表接口
export const advanceTax_getApproveProjectPage = app_server + '/project/getApproveProjectPage';//退预缴申请选择项目接口
export const getAdvanceTaxProjectById = app_server + '/advanceTax/getAdvanceTaxProjectById';//退预缴所属合同信息接口
export const addOrUpdateAdvanceTaxApply = app_server + '/advanceTaxApply/addOrUpdateAdvanceTaxApply';//新增/编辑-退预缴申请接口
export const advanceTax_getAdvanceTaxApplyInfo = app_server + '/advanceTaxApply/getAdvanceTaxApplyInfo';//预缴资料
export const getAdvanceTaxApplyRecordPage = app_server + '/advanceTaxApply/getAdvanceTaxApplyRecordPage';//已预缴记录接口
export const advanceTax_auditAdvanceTaxApply = app_server + '/advanceTaxApply/auditAdvanceTaxApply';//审核退预缴申请接口
export const delAdvanceTaxApplyById = app_server + '/advanceTaxApply/delAdvanceTaxApplyById';//删除预缴申请接口
export const checkAdvanceTaxReceiptNo = app_server + '/advanceTax/checkAdvanceTaxReceiptNo';//校验重复完税凭证号接口
export const advanceTaxApply_disagree = app_server + '/advanceTaxApply/disagreeAdvanceTaxApply';//审核不同意
export const advanceTaxApply_change = app_server + '/advanceTaxApply/changeAdvanceTaxApply';//审核
export const advanceTaxApply_agree = app_server + '/advanceTaxApply/agreeAdvanceTaxApply';//审核
export const advanceTaxApply_return = app_server + '/advanceTaxApply/returnAdvanceTaxApply';//审核
export const advanceTaxApply_complete = app_server + '/advanceTaxApply/completeAdvanceTaxApply';//审核

export const advanceTaxApply_restartAdvanceTaxById = app_server + '/advanceTaxApply/restartAdvanceTaxById';//预缴税费流程重启
export const advanceTaxApply_delAdvanceTaxById = app_server + '/advanceTaxApply/delAdvanceTaxById';//删除开票信息
export const advanceTaxApply_delAdvanceTaxApplyById = app_server + '/advanceTaxApply/delAdvanceTaxApplyById';//删除预缴申请

// 财务统计
export const financeStat_project_pageData = app_server + '/financeStat/project/pageData';
export const financeStat_project_findById = app_server + '/financeStat/project/findById';
export const financeStat_income_autoCalList = app_server + '/financeStat/income/autoCalList';
export const financeStat_pm_findById = app_server + '/financeStat/pm/mainFinance';
export const financeStat_pm_financeitemPage = app_server + '/financeStat/pm/financeitemPage';
export const financeStat_pm_financeitemTotal = app_server + '/financeStat/pm/financeitemTotal';
export const financeStat_income_excel = app_server + '/financeStat/income/autoCalListExport';//项目视图 数据导出
export const financeStat_export_project_view = app_server + '/financeStat/export_project_view';//项目视图列表导出


// 申请类
export const applyData_getPage = app_server + '/applyData/getPage';
export const applyData_getCash_getPage = app_server + '/apply/getCashPage';          //获取我要提现申请列表

export const applyData_get_dataInfo = app_server + '/apply/getDataInfo';            //获取各种申请详情

export const applyData_save_stamp = app_server + '/apply/saveStamp';            //保存盖章申请
export const applyData_audit_stamp = app_server + '/apply/auditStamp';            //审核盖章申请
export const delete_stamp = app_server + '/sealApply/deleteStampFile';      //删除盖章文件

export const applyData_save_invoiceBill = app_server + '/apply/saveInvoiceBill';            //保存开票申请
export const applyData_audit_invoiceBill = app_server + '/apply/auditInvoiceBill';            //审核开票申请

export const applyData_save_addCredit = app_server + '/apply/saveAddCredit';            //保存授信提额申请
export const applyData_audit_addCredit = app_server + '/apply/auditAddCredit';            //审核授信提额申请

export const applyData_save_getCash = app_server + '/apply/saveGetCash';            //保存提现申请
export const applyData_audit_getCash = app_server + '/apply/auditGetCash';            //审核提现申请






//退预缴相关
export const xmFinance_item_get_page = app_server + '/xmFinance_item/get_page';            //获取退预缴列表
export const xmFinance_item_find_by_id = app_server + '/xmFinance_item/find_by_id';            //根据id获取退预缴
export const xmFinance_item_save_draft = app_server + '/xmFinance_item/save_draft';            //保存退预缴草稿
export const xmFinance_item_audit_ok_by_finance = app_server + '/xmFinance_item/audit_ok_by_finance';   //财务发送审核
export const xmFinance_item_audit_ok_by_fm = app_server + '/xmFinance_item/audit_ok_by_fm';   //财务经理发送审核
export const xmFinance_item_delete_by_id = app_server + '/xmFinance_item/delete_by_id';   //删除退预缴信息，只有草稿状态才可以删除

export const getProjectAdvanceTaxList = app_server + '/advanceTax/getProjectAdvanceTaxList';   //获取项目退预缴详情接口



// 代付申请相关
export const applyData_save_otherMall = app_server + '/apply/saveOtherMall';            //保存代付材料申请
export const payRoll_staging_payRollContract = app_server + '/payRoll/staging_payRollContract';   //保存代付材料申请
export const payRoll_delete_payRollContract = app_server + '/payRoll/delete_payRollContract';   //删除代付材料申请
export const payRoll_checkRepeatPaidMaterial = app_server + '/payRoll/checkRepeatPaidMaterial';   //代付材料申请购销合同重复录入校验接口
export const applyData_audit_otherMall = app_server + '/apply/auditOtherMall';            //审核代付材料申请
export const disagreeOtherMall = app_server + '/apply/disagreeOtherMall';            //拒绝代付材料申请接口
export const changeOtherMall = app_server + '/apply/changeOtherMall';            //转交代付材料申请接口
export const disagreeBidBondApply = app_server + '/apply/disagreeBidBondApply';            //拒绝投标保证金申请接口
export const changeBidBondApply = app_server + '/apply/changeBidBondApply';            //转交投标保证金申请接口
export const disagreeTenementDepositApply = app_server + '/apply/disagreeTenementDepositApply';            //拒绝物业押金申请接口
export const changeTenementDepositApply = app_server + '/apply/changeTenementDepositApply';            //转交物业押金申请接口
export const materialTicketInfo_deleteXmFinanceItemManual = app_server + '/materialTicketInfo/deleteXmFinanceItemManual'
export const materialTicketInfo_deleteXmFinanceItemManualBehalf = app_server + '/materialTicketInfo/deleteXmFinanceItemManualBehalf'


export const applyData_getOtherMallPage = app_server + '/apply/getOtherMallPage'; //代付申请列表
// export const applyData_getOtherMallEdit = app_server+'/apply/getOtherMallEdit'; //获取代付材料详细信息
export const apply_otherMallPageExport = app_server + '/apply/OtherMallPageExport'; //代付材料列表导出
export const editBillMaterialByApplyId = app_server + '/bill_material/editBillMaterialByApplyId';   //代付材料列表清空
export const applyData_saveOtherMall = app_server + '/payRoll/addPayRollContract';   //提交审核
export const apply_getSupplyList = app_server + '/apply/getSupplierName';     //获取供应商名称
export const getSupplierChooseList = app_server + '/supplier/getSupplierChooseList';    //获取选择供应商列表
export const apply_get_bankList = app_server + '/bankInfo/get_bank_list';   // 获取银行列表
export const apply_get_branchList = app_server + '/payRoll/getSupplierBranchName';   // 获取支行列表
export const apply_OtherMall_edit = app_server + '/apply/getOtherMallEdit';   // 获取代付材料详细信息
export const apply_OtherMall_select_pro = app_server + '/apply/projectByOtherMall';   // 新增代付申请选择项目
export const apply_OtherMall_print = app_server + '/apply/otherMallPrinting';   // 新增代付申请选择项目
export const apply_otherMallPayment = app_server + '/apply/otherMallPayment';   // 确认付款
export const apply_saveApplyAmount = app_server + '/payRoll/saveApplyAmount';   //生成代付材料申请单
export const apply_getDFOddNumbers = app_server + '/apply/getDFOddNumbers';   //自动生成代付单号
export const apply_getOtherMallCallout = app_server + '/apply/otherMallCallout';   //代付申请列表标注
export const apply_project_info = app_server + '/apply/projectByOtherMallInfo';
export const getNoAssociatedMaterial = app_server + '/materialTicket/getNoAssociatedMaterial';//代付统计进项票无头票接口
export const getNoDeductionMaterialPage = app_server + '/materialTicketInfo/getNoDeductionMaterialPage';//代付统计进项票无头票接口
export const getPaidMaterialTicket = app_server + '/materialTicket/getPaidMaterialTicket';//代付材料编辑/详情获取进项票信息接口
export const cancelRelevanceMaterial = app_server + '/materialTicketInfo/cancelRelevanceMaterial';//代付材料删除已关联无头票接口
export const relevanceMaterialTicket = app_server + '/materialTicket/relevanceMaterialTicket';//代付材料审核关联无头票接口
export const getOtherMallBillMaterials = app_server + '/apply/getOtherMallBillMaterials';//代付材料清单接口
export const del_buy_apply = app_server + '/apply/delBuyApplyData';//删除代付材料申请付款记录
export const del_process_apply = app_server + '/apply/delApplyDataProcess';//删除代付材料申请流程
export const reset_process_apply = app_server + '/apply/resetApplyDataProcess';//重启代付材料申请流程



//购销合同  
export const payRoll_contract_list = app_server + '/payRoll/payRollContractPage';   // 新增购销合同列表
export const payRoll_addPayRollContract = app_server + '/payRoll/addPayRollContract';   // 新增购销合同
export const payRoll_savePayRollContract = app_server + '/payRoll/savePayRollContract';   // 新的购销合同的保存
export const payRoll_updatePayRollContract = app_server + '/payRoll/updatePayRollContractInfo';   // 新增购销合同
export const payRoll_getPayRollContractNo = app_server + '/payRoll/getPayRollContractNo';   // 获取代付合同编号
export const payRoll_getSupplyList = app_server + '/payRoll/getSupplierName';   // 供应商
export const addNewSupplier = app_server + '/supplier/saveSupplier';   //新增供应商
export const payRoll_branchName = app_server + '/payRoll/getSupplierBranchName';   // 购销合同审核
export const payRoll_payRollContractInfo = app_server + '/payRoll/payRollContractInfo';   // 购销合同详情
export const payRoll_auditContract = app_server + '/payRoll/auditContract';   // 购销合同审核
export const payRoll_savePayRollInvoices = app_server + '/payRoll/savePayRollInvoices';   //保存发票附件
export const payRoll_getPayRollContractPageByProject = app_server + '/payRoll/getPayRollContractPageByProject';   // 新增代付申请选择已有购销合同
export const payRoll_savePayRollMarkContent = app_server + '/payRoll/savePayRollMarkContent';   // 代付资料员编辑购销合同标注接口
export const apply_seal_DataPage = app_server + '/applyData/getProjectSealApplyPage';   // 盖章申请列表接口
export const apply_seal_getProject = app_server + '/applyData/getSealProjectPage';   // 盖章申请-选择项目接口
export const apply_seal_get_detail = app_server + '/applyData/getProjectSealApplyInfo';   // 盖章申请详情接口
export const apply_seal_type = app_server + '/applyData/getSealApplyType';   // 盖章申请详情接口
export const apply_seal_save = app_server + '/applyData/saveSealApply';   // 保存/审核盖章申请接口
export const exportPayRollContractPage = app_server + '/payRoll/exportPayRollContractPage';   // 材料购销合同导出数据

//劳务支付
export const apply_getLaborApplyPage = app_server + '/apply/getLaborApplyPage'; //劳务支付选择项目
export const apply_getProjectByLabor = app_server + '/apply/getProjectByLabor'; //劳务支付选择项目
export const apply_getProjectDeductionsInfo = app_server + '/apply/getProjectDeductionsInfo'; //选择项目详情
export const apply_laborOddNumbers = app_server + '/apply/laborOddNumbers'; //获取劳务支付单号
export const apply_addLaborApply = app_server + '/apply/addLaborApply'; //提交保存
export const apply_saveLaborApply = app_server + '/apply/saveLaborApply'; //保存劳务支付
export const apply_laborConfirmStatus = app_server + '/apply/laborConfirmStatus'; //劳务支付-财务经理审核
export const apply_laborApplyInfo = app_server + '/apply/laborApplyInfo'; //劳务支付-详情
export const apply_addLaborPayment = app_server + '/apply/addLaborPayment'; //劳务支付-出纳付款
export const apply_getProjectIncomeInfo = app_server + '/apply/getProjectIncomeInfo'; //劳务支付请款勾选项目
export const apply_editLaborApplyInfo = app_server + '/apply/editLaborApplyInfo'; //劳务支付编辑
export const apply_delete_labor = app_server + '/apply/delete_labor'; //劳务支付列表删除
export const disAgreeLaborApply = app_server + '/apply/disAgreeLaborApply'; //劳务支付拒绝申请接口
export const changeLaborApply = app_server + '/apply/changeLaborApply'; //劳务支付转交接口

export const userBank_getDefaultUserBank = app_server + '/userBank/getDefaultUserBank'; //劳务支付-获取用户默认银行卡
export const getSettleDefaultUserBank = app_server + '/userBank/getSettleDefaultUserBank';
export const userBank_getUserBankList = app_server + '/userBank/getUserBankList'; //劳务支付-选择银行
export const userBank_saveUserBank = app_server + '/userBank/saveUserBank'; //劳务支付-选择银行
export const userBank_editBankAttach = app_server + '/userBank/editBankAttach'; //劳务支付-修改银行卡附件

export const finance_submitAudit = app_server + '/finance/submitAudit'; //劳务支付-新增编辑劳务支付退风险金接口
export const apply_getProjectDedOfBackRisk = app_server + '/apply/getProjectDedOfBackRisk'; //劳务支付退风险金项目详情接口
export const advanceTax_getProjectInfo = app_server + '/advanceTax/getProjectInfo'; //劳务支付退预缴项目详情接口
export const finance_getApplyInfo = app_server + '/finance/getApplyInfo'; //劳务支付退风险金申请详情接口
export const finance_doAudit = app_server + '/finance/doAudit'; //劳务支付退风险金审核按钮接口
export const finance_modifyPayAmount = app_server + '/finance/modifyPayAmount'; //劳务支付修改付款金额接口
export const finance_doPay = app_server + '/finance/doPay'; //劳务支付退风险金付款
export const finance_doDelete = app_server + '/finance/doDelete'; //劳务支付退风险金删除
export const editAdvanceTaxAmount = app_server + '/advanceTax/editAdvanceTaxAmount'; //财务经理修改退预缴金额接口
export const finance_print = app_server + '/finance/doPrint'; //打印
export const finance_disagreeApply = app_server + '/finance/disagreeApply'; //拒绝退预缴、退风险金接口
export const finance_changeApply = app_server + '/finance/changeApply'; //转交退预缴、退风险金接口
export const printApplyInfo = app_server + '/apply/printApplyInfo'; //打印次数
export const apply_checkWorkerSalaryUploadData = app_server + '/apply/checkWorkerSalaryUploadData'; //工资表导入校验





//授信管理相关
export const credit_apply_list = app_server + '/apply/getAddCreditPage';//授信管理列表
export const credit_detail = app_server + '/apply/getAddCreditInfo';//授信详情
export const credit_apply_audit = app_server + '/apply/auditAddCredit';//授信审核
export const getCreditOrderPage = app_server + '/credit/getCreditOrderPage';//授信订单列表
export const checkUserOrder = app_server + '/apply/checkUserOrder';//授信订单核实材料
export const auditCreditOrderByFM = app_server + '/credit/auditCreditOrderByFM';//授信订单-财务经理审核接口
export const creditOrderPay = app_server + '/credit/creditOrderPay';//授信出纳付款接口
export const getCreditOrderInfo = app_server + '/credit/getCreditOrderInfo';//授信订单详情-基本信息/所属项目接口
export const getCreditOrderRepaymentList = app_server + '/credit/getCreditOrderRepaymentList';//授信订单详情-还款/退款记录接口
export const getCreditOrderGoodsList = app_server + '/credit/getCreditOrderGoodsList';//授信订单详情-材料清单接口
export const credit_pm_credit_list = app_server + '/credit/getPmCreditPage';//授信人员列表
export const credit_pm_credit_info = app_server + '/credit/getPmCreditInfo';//授信人员详情-统计信息
export const credit_pm_credit_project_info = app_server + '/credit/getPmCreditProjectPage';//授信人员详情-项目明细
export const updateCreditAmount = app_server + '/apply/updateCreditAmount';//授信申请-客服总监修改报批额度接口
export const getCreditApplyPortrait = app_server + '/apply/getCreditApplyPortrait';//授信提额-详情查看画像评估接口
export const updateCreditApplyPortrait = app_server + '/project/updateCreditProjectPortrait';//授信提额-编辑画像接口
export const updateSysCreditApplyPortrait = app_server + '/project/updateSysCreditProjectPortrait';//授信提额-详情画像自动获取接口
export const auditCreditApplyPortrait = app_server + '/apply/auditCreditApplyPortrait';//授信提额-画像评估接口
export const getCreditPortraitAuditByPortraitId = app_server + '/apply/getCreditPortraitAuditByPortraitId';//授信提额-画像评估意见列表接口
export const getCreditProjectPage = app_server + '/credit/getCreditProjectPage';//授信提额-画像评估意见列表接口
export const getCreditApplyPortraitByProjectId = app_server + '/apply/getCreditApplyPortraitByProjectId';//项目获取授信画像接口
export const get_credit_portrait = app_server + '/credit/getCreditPortrait';//项目获取授信画像接口
export const creditApply_agree = app_server + '/credit/agreeCreditApply';//项目授信申请 - 同意
export const creditApply_disagree = app_server + '/credit/disagreeCreditApply';//项目授信申请 - 拒绝
export const creditApply_return = app_server + '/credit/returnCreditApply';//项目授信申请 - 退回
export const creditApply_change = app_server + '/credit/changeCreditApply';//项目授信申请 - 转交
export const creditApply_deal = app_server + '/credit/dealCreditApply';//项目授信申请 - 处理
export const creditApply_submit = app_server + '/credit/submitCreditApply';//项目授信申请 - 处理

export const credit_restartCreditApply = app_server + '/credit/restartCreditApply';//项目授信申请 - 重启流程




//用款申请
export const payment_apply_list = app_server + '/paymentRecords/page';//用款申请列表
export const payment_apply_info = app_server + '/paymentRecords/info';//用款申请列表

//存储文件地址
export const common_save_attachment = app_server + '/common/save_attachment';

//工程管理
export const back_user_supervisor_list = app_server + '/back_user/backUser_page'; //获取监理列表
export const project_manage_list = app_server + '/projectManagement/project_management_page'; //获取工程管理列表
export const project_manage_info = app_server + '/projectManagement/project_management_info'; //工程管理详情
export const project_manage_assign_supervisor = app_server + '/projectManagement/add_project_management_supervisor'; //工程管理详情
export const project_manage_cancel_dispatch = app_server + '/projectManagement/project_management_cancel_dispatch'; //申请取消派单
export const project_manage_cancel_audit = app_server + '/projectManagement/project_management_cancel_audit'; //申请取消派单
export const project_manage_no_supervisors = app_server + '/projectManagement/no_supervisors_to_project'; //项目不派单
export const project_manage_monitoring_statistics = app_server + '/projectManagement/project_monitoring_statistics'; //工地检查评分统计表
export const project_get_play_table_list = app_server + '/projectManagement/get_play_table_list'; //工程详情监察列表
export const project_get_play_table_list_info = app_server + '/projectManagement/get_play_table'; //打分表详情
export const project_monitoring_statistics_export = app_server + '/projectManagement/project_monitoring_statistics_export'; //工地检查评分统计表数据导出
export const project_Guarantee_info = app_server + '/guaranteeLetter/getGuaranteeLetterByListProject'; //保函列表数据
export const project_get_rollContract = app_server + '/project/getPayRollContractInfoListByProject';//代付材料购销合同
export const project_get_billMaterials = app_server + '/project/getBillMaterialsListByProject';//代付材料材料
export const guaranteeLetter_addGuaranteeLetter = app_server + '/guaranteeLetter/addGuaranteeLetter';//保函页签添加保函
export const getCategoryId = app_server + '/insurance/getCategoryId'

export const project_manager_monitoring_statistics = app_server + '/projectManagement/project_manager_monitoring_statistics'; //工程项目总监打分统计
export const project_manager_monitoring_statistics_export = app_server + '/projectManagement/project_manager_monitoring_statistics_export'; //工程项目总监打分统计 导出
export const project_return_page = app_server + '/projectManagement/project_return_page'; //回访表
export const project_return_export = app_server + '/projectManagement/project_return_export'; //回访表
export const project_manage__KPI_statistics = app_server + '/projectManagement/supervisor_KPI_statistics'; //工程监理工地管理KPI考评表
export const project_manager_KPI_statistics_export = app_server + '/projectManagement/supervisor_KPI_statistics_export'; //工程监理工地管理KPI考评表导出
export const project_updateConstructionSpecification = app_server + '/contractInfo/updateConstructionSpecification'; //工程详情编辑施工规范
export const project_getDeviceListById = app_server + '/projectDevice/getDeviceListById'; //视频监控列表
export const project_addProjectMonitorSnapshot = app_server + '/projectDevice/addProjectMonitorSnapshot'; //视频监控截图
export const project_getProjectMonitorInfoById = app_server + '/projectDevice/getProjectMonitorInfoById'; //项目监控视频播放地址接口
export const openEquipment = app_server + '/projectDevice/OpenEquipment'; //视频监控批量开启设备拉流接口

export const project_getProjectExList = app_server + '/project/getProjectExList'; //派单管理详情-异常 project/getProjectMaterialList
export const projectHonor_saveProjectHonor = app_server + '/projectHonor/saveProjectHonor'; //新增项目荣誉
export const projectHonor_getProjectHonorByProjectId = app_server + '/projectHonor/getProjectHonorByProjectId'; //获取项目荣誉
export const project_getProjectMaterialList = app_server + '/project/getProjectMaterialList'; //派单管理详情-使用材料送货单列表
export const project_getProjectMaterialDetail = app_server + '/project/getProjectMaterialDetail'; //派单管理详情-使用材料送货单材料清单接口
export const project_getProjectMaterialProductPage = app_server + '/project/getProjectMaterialProductPage'; //派单管理详情-使用材料送货单材料接口

export const projectDispatchPerson_getDispatchPersonPage = app_server + '/projectDispatchPerson/getDispatchPersonPage'; //派单管理 工程派单查询人员列表
export const projectManagement_editProjectDispatch = app_server + '/projectManagement/editProjectDispatch'; //派单管理 工程派单
export const projectDispatchPerson_getProjectDispatchPersonInfo = app_server + '/projectDispatchPerson/getProjectDispatchPersonInfo'; //派单管理 获取项目已派单人员
export const projectDispatchPerson_getProjectDispatchPersonRecord = app_server + '/projectDispatchPerson/getProjectDispatchPersonRecord'; //工程详情-派单记录
export const attendance_getWorkerInfoList = app_server + '/attendance/getWorkerInfoList'; //工人信息列表
export const attendance_getUnitList = app_server + '/attendance/getUnitList'; //单位下拉框
export const attendance_getTeamList = app_server + '/attendance/getTeamList'; //班组下拉框
export const attendance_addProjectUnit = app_server + '/attendance/addProjectUnit'; //工人进场 - 新增单位
export const attendance_addProjectUnitTeam = app_server + '/attendance/addProjectUnitTeam'; //工人进场 - 新增班组
export const attendance_getEditWorkerInfo = app_server + '/attendance/editPerson';   //工人进场-编辑获取工人信息
export const attendance_getPersonInfoByIdcardNo = app_server + '/attendance/getPersonInfoByIdcardNo'; //工人进场 - 身份证查找
export const attendance_getOccupationCategoryList = app_server + '/attendance/getOccupationCategoryList'; //工人进场 - 查询工种
export const attendance_addWorker = app_server + '/attendance/addWorker'; //工人进场 - 保存
export const attendance_createQrCode = app_server + '/attendance/createQrCode'; //生成二维码
export const attendance_getAttendanceRecordList = app_server + '/attendance/getAttendanceRecordList'; //获取考勤记录列表
export const attendance_multiImport = app_server + '/attendance/submitUploadPersonInfo';  //批量导入工人
export const attendance_checkWorkerData = app_server + '/attendance/saveUploadPersonInfo';   //检查批量导入数据
export const attendance_editGradeAndScore = app_server + '/attendance/editGradeAndScore';  //评级和打分
export const attendance_getWorkerIssueList = app_server + '/attendance/getWorkerIssueList';  //工人异常信息列表
export const attendance_addWorkerIssue = app_server + '/attendance/addWorkerIssue';   //添加工人异常信息
export const attendance_releaseWorkerIssue = app_server + '/attendance/releaseWorkerIssue';  //解除监控
export const attendance_editWorkerIssue = app_server + '/attendance/editWorkerIssue';    //编辑工人异常
export const attendance_deleteWorkerIssue = app_server + '/attendance/deleteWorkerIssue';   //删除工人异常
export const attendance_updatePersonInfo = app_server + '/attendance/updatePersonInfo';    //编辑工人信息
export const worker_salary_pageInfo = app_server + '/workerSalary/getWorkerSalaryPage';    //工资记录
export const exportAttendanceRecord = app_server + '/attendance/exportAttendanceRecord'; // 工人考勤导出
export const getAttendanceDeviceListByProjectId = app_server + '/attendanceDevice/getAttendanceDeviceListByProjectId'; // 设备添加
export const getChooseAttendanceDeviceList = app_server + '/attendanceDevice/getChooseAttendanceDeviceList'; // 添加考勤机
export const stopAttendanceDeviceById = app_server + '/attendanceDevice/stopAttendanceDeviceById'; // 停用考勤机
export const delAttendanceDeviceById = app_server + '/attendanceDevice/delAttendanceDeviceById'; // 删除考勤机
export const addAttendanceDeviceByProjectId = app_server + '/attendanceDevice/addAttendanceDeviceByProjectId';

//工人总表
export const attendance_allWorkerInfoList = app_server + '/attendance/allWorkerInfoList'; //工人总表接口
export const attendance_workerDetailsInfo = app_server + '/attendance/workerDetailsInfo'; //工人信息详情接口
export const attendance_projectExperienceList = app_server + '/attendance/projectExperienceList'; //工人项目经历

//用章申请
export const getStampPage = app_server + '/pc/stampData/getStampPage'; //用章列表
export const getDetail = app_server + '/pc/stampData/getDetail'; //用章详情

export const project_manage_export = app_server + '/projectManagement/project_management_page_export'; //工程列表数据导出
export const project_commission_export = app_server + '/sysAllowanceDetail/exportSysAllowanceBySUPV'; //质监员提成导出



//销项票

export const findInvoiceList = app_server + '/apply/findInvoiceList'; //销项票-列表
export const exportSalesTicketList = app_server + '/apply/exportSalesTicketList'; //销项票-列表导出[模板导出]
export const findProjectContractList = app_server + '/project/findProjectContractList'; //销项票-添加时选择工程列表[查询工程列表]

export const invoice_findBillingProjectList = app_server + '/invoice/findBillingProjectList'; //销项票-添加时选择工程列表[查询工程列表]
export const invoice_findBillingProjectById = app_server + '/invoice/findBillingProjectById'; //销项票-新增申请详情
export const enum_data_find_invoice_content_type = app_server + '/enum_data/find_invoice_content_type'; //销项票发票内容类型
export const invoice_saveInvoiceApply = app_server + '/invoice/saveInvoiceApply'; //新增销项票提交审核
export const invoice_getInvoiceApplyPage = app_server + '/invoice/getInvoiceApplyPage'; //销项票列表
export const invoice_getInvoiceApplyInfo = app_server + '/invoice/getInvoiceApplyInfo'; //销项票-编辑/详情/打印
export const invoice_checkInvoiceNos = app_server + '/invoice/checkInvoiceNos'; //销项票-校验重复发票号
export const invoice_saveInvoiceNo = app_server + '/invoice/saveInvoiceNo'; //销项票-开票专员开票
export const invoice_deleteInvoiceApply = app_server + '/invoice/deleteInvoiceApply'; //销项票-删除销项票申请
export const invoice_auditInvoiceApply = app_server + '/invoice/auditInvoiceApply'; //销项票-财务经理审核
export const invoice_invoiceApply_page_export = app_server + '/invoice/invoiceApply_page_export'; //销项票-财务经理审核
export const invoice_findNewestInvoiceByProjectId = app_server + '/invoice/findNewestInvoiceByProjectId'; //销项票-新增销项票自动带出
export const invoice_agree = app_server + '/invoiceApplyData/agreeInvoiceApplyData'; //销项票审核同意
export const invoice_disagree = app_server + '/invoiceApplyData/disagreeInvoiceApplyData'; //销项票审核同意
export const invoice_change = app_server + '/invoiceApplyData/changeInvoiceApplyData'; //销项票审核同意
export const invoice_return = app_server + '/invoiceApplyData/returnInvoiceApplyData'; //销项票审核同意
export const invoice_complete = app_server + '/invoiceApplyData/completeInvoiceApplyData'; //销项票审核同意

//销项票作废红冲
// export const invoice_getInvoiceApplyPage = app_server+'/invoice/getInvoiceApplyPage'; //销项票作废记录列表
export const invoice_saveVoidApply = app_server + '/invoice/saveVoidApply'; //销项票新增或编辑作废记录
export const invoice_saveRedPunchApply = app_server + '/invoice/saveRedPunchApply'; //销项票新增或编辑红冲记录
export const invoice_getVoidApplyInfo = app_server + '/invoice/getVoidApplyInfo'; //销项票红冲作废回显
//红冲审核按钮
export const invoice_agree_red_rush = app_server + '/invoiceApplyData/agreeInvoiceApplyDataRedRush'; //红冲审核同意
export const invoice_disagree_red_rush = app_server + '/invoiceApplyData/disagreeInvoiceApplyDataRedRush'; //红冲审核拒绝
export const invoice_return_red_rush = app_server + '/invoiceApplyData/returnInvoiceApplyDataRedRush'; //红冲审核退回
export const invoice_change_red_rush = app_server + '/invoiceApplyData/changeInvoiceApplyDataRedRush'; //红冲审核转交
export const invoice_complete_red_rush = app_server + '/invoiceApplyData/completeInvoiceApplyDataRedRush'; //红冲审核完成

export const invoice_restartInvoiceApplyDataBizItemId = app_server + '/invoice/restartInvoiceApplyDataBizItemId'; //销项票-流程重启
export const invoice_deleteInvoiceApplyData = app_server + '/invoice/deleteInvoiceApplyData'; //销项票-删除开票信息

//作废记录
export const invoice_confirmVoid = app_server + '/invoice/confirmVoid'; //
//作废审核按钮
export const invoice_agree_void = app_server + '/invoiceApplyData/agreeInvoiceApplyDataVoid'; //作废审核同意
export const invoice_disagree_void = app_server + '/invoiceApplyData/disagreeInvoiceApplyDataVoid'; //作废审核拒绝
export const invoice_return_void = app_server + '/invoiceApplyData/returnInvoiceApplyDataVoid'; //作废审核退回
export const invoice_change_void = app_server + '/invoiceApplyData/changeInvoiceApplyDataVoid'; //作废审核转交
export const invoice_complete_void = app_server + '/invoiceApplyData/completeInvoiceApplyDataVoid'; //作废审核完成




export const findProjectContractInfo = app_server + '/project/findProjectContractInfo'; //销项票-工程详情
export const checkExcelSalesTicket = app_server + '/apply/checkExcelSalesTicket'; //销项票-excel数据校验
export const batchExportSalesTicketUnsuccessList = app_server + '/apply/batchExportSalesTicketUnsuccessList'; //销项票-校验数据失败列表导出
export const batchImportSalesTicket = app_server + '/apply/batchImportSalesTicket'; //销项票-校验数据成功列表上传
export const addSalesTicket = app_server + '/apply/addSalesTicket'; //销项票-添加新的销项票

export const materialTicketList = app_server + '/materialTicketInfo/getMaterialTicketInfoPage'; //进项票列表
export const getMaterialTicketProject = app_server + '/materialTicket/getMaterialTicketProject'; //进项票-新增进项材料票选择项目交票接口
export const getMaterialTicketPurchace = app_server + '/materialTicket/getMaterialTicketPurchace';
export const saveMaterialTicketApply = app_server + '/materialTicket/saveMaterialTicketApply'; //进项票-新增编辑进项票接口
export const getMaterialTicketInfo = app_server + '/materialTicketInfo/getMaterialTicketInfo'; //进项票详情
export const delMaterialTicketInfo = app_server + '/materialTicketInfo/delMaterialTicketInfo'; //删除进项票申请
export const exportMaterialTicketInfoPage = app_server + '/materialTicketInfo/exportMaterialTicketInfoPage'; //进项票列表导出
export const auditMaterialTicketApply = app_server + '/materialTicket/auditMaterialTicketApply'; //进项票审核
export const relevanceMaterial = app_server + '/materialTicket/relevanceMaterial'; //审核通过进项票关联购销合同
export const materialTicket_check_upload = app_server + '/materialTicket/checkUploadTicketData';//进项票批量导入
export const materialTicket_repeat = app_server + '/materialTicket/comparisonRepeatMaterialTicket';//重复对比
export const materialTicket_export_errorData = app_server + '/materialTicket/exportMaterialTicketErrorData';//导出错误数据
export const materialTicket_saveUpload = app_server + '/materialTicket/saveUploadMaterialTicket';//确定导入


//投标保证金 
export const apply_projectByBidBond = app_server + '/apply/projectByBidBond'    //新增保证金-选择项目接口
export const apply_saveBidBond = app_server + '/apply/saveBidBond'              //新增编辑投标保证金申请
export const apply_realEstate_collateral_info = app_server + '/apply/realEstate_collateral_info'              //物业押金和保证金：详情-打印-编辑接口


//执行院长
export const project_getStylistPro = app_server + '/project/getStylistPro'  //设计师列表
export const project_getContractInfoPro = app_server + '/project/getContractInfoPro'  //设计师合同列表
export const project_stylistContractInfoExcel = app_server + '/contractInfo/stylistContractInfoExcel'//设计师合同导出

//资料管理
export const flie_workingAndFinish = app_server + '/project/workingAndFinish'  //资料列表
export const flie_projectDocDir = app_server + '/project/projectDocDir'  //资料列表
export const flie_projectDocFile = app_server + '/project/projectDocFile'  //
export const flie_delete = app_server + '/project/deleteProjectDocFile'  //删除
export const flie_saveDocFile = app_server + '/project/saveDocFile'  //保存
export const find_by_idCard = app_server + '/proManager/findByIdCard'  //保存

export const project_saveDocFileBatch = app_server + '/project/saveDocFileBatch'  //小程序项目资料上传保存
export const authorizationToAppJump = app_server + '/authorizationToAppJump'  //小程序项目资料上传授权

//营销管理相关
//投诉管理

export const complaint_getComplaintTypeCats = app_server + '/complaint/getComplaintTypeCats'  // 投诉类型
export const complaint_page_date = app_server + '/complaint/page_date'  //投诉列表
export const proManager_getComplaintsProManagerPage = app_server + '/proManager/getComplaintsProManagerPage'  //新增投诉页面-选择被投诉人
export const project_getComplaintProject = app_server + '/project/getComplaintProject'  //新增投诉页面-选择投诉项目
export const complaint_saveOrEdit = app_server + '/complaint/saveOrEdit'  //新增投诉页面-提交
export const complaint_complainantDetail = app_server + '/complaint/complainantDetail'  //投诉详情
export const complaint_invalid = app_server + '/complaint/invalid'  //投诉驳回
export const complaint_dispatch = app_server + '/complaint/dispatch'  //投诉转交
export const complaint_dealwithUser = app_server + '/complaint/dealwithUser'  //转交-获取处理人
export const complaint_dealwith = app_server + '/complaint/dealwith'  //投诉--处理
export const complaint_frozen = app_server + '/complaint/frozen'  //投诉--冻结项目
export const complaint_getPMComplaint = app_server + '/complaint/getPMComplaint'  //项目总监投诉
export const report_finance_statistics_summary_print = app_server + '/report/finance_statistics_summary_print'  //财务数据详情-打印结算单
export const apply_addOtherAmount = app_server + '/apply/addOtherAmount'  //劳务支付详情页 打印审核前的保存
export const complaint_saveDealWith = app_server + '/complaint/saveDealWith'  //处理弹窗保存按钮接口
export const complaint_returnComplaint = app_server + '/complaint/returnComplaint'  //处理弹窗退回按钮接口
export const complaint_grade = app_server + '/complaint/grade'  //评级接口
export const complaint_completeComplaint = app_server + '/complaint/completeComplaint'  //完成处理
export const complaint_agreeComplaint = app_server + '/complaint/agreeComplaint'  //同意
export const complaint_disagreeComplaint = app_server + '/complaint/disagreeComplaint'  //拒绝
export const complaint_changeComplaint = app_server + '/complaint/changeComplaint'  //转交
export const complaint_returnComplaints = app_server + '/complaint/returnComplaints'  //退回
export const complaint_sumbitComplaint = app_server + '/complaint/sumbitComplaint'  //新增/编辑 投诉

export const complaint_restartComplaintApply = app_server + '/complaint/restartComplaintApply'  //重启流程
export const complaint_deleteComplaintApply = app_server + '/complaint/deleteComplaintApply'  //删除流程 

//诉讼管理
export const litigation_getProjectPage = app_server + '/projectLitigation/getProjectPage'  //新增诉讼查询项目接口
export const addProjectLitigation = app_server + '/projectLitigation/addProjectLitigation'  //新增诉讼接口
export const saveProjectLitigation = app_server + '/projectLitigation/saveProjectLitigation'  //暂存诉讼接口
export const getProjectLitigationPage = app_server + '/projectLitigation/getProjectLitigationPage'  //诉讼列表接口
export const getProjectLitigationTreatment = app_server + '/projectLitigation/getProjectLitigationTreatment'  //获取处理人接口
export const updateLitigationHandlePerson = app_server + '/projectLitigation/updateLitigationHandlePerson'  //转交接口
export const addLitigationTreatmentScheme = app_server + '/projectLitigation/addLitigationTreatmentScheme'  //添加方案
export const updateLitigationResult = app_server + '/projectLitigation/updateLitigationResult'  //完成处理接口
export const delProjectLitigation = app_server + '/projectLitigation/delProjectLitigation'  //删除接口
export const getLitigationInfo = app_server + '/projectLitigation/getLitigationInfo'  //诉讼详情接口
export const auditProjectLitigation = app_server + '/projectLitigation/auditProjectLitigation'  //审核诉讼详情接口
export const casualty_grade = app_server + '/casualtyReport/grade'  //事故评级接口

export const projectLitigation_restartLitigationApply = app_server + '/projectLitigation/restartLitigationApply'  //重启流程
export const projectLitigation_delProjectLitigation = app_server + '/projectLitigation/delProjectLitigation'  //删除流程


//其他异常
export const getIssuePage = app_server + '/issue/getIssuePage'  //其他异常列表
export const issue_editIssue = app_server + '/issue/editIssue'  //其他异常列表
export const issue_deleteIssue = app_server + '/issue/deleteIssue'  //其他异常列表
export const issue_releaseIssue = app_server + '/issue/releaseIssue'  //其他异常列表
export const issut_workerList = app_server + '/attendance/getWorkerList'  //获取工人列表


//营销管理相关
//行政处罚
export const get_project_punishment_list = app_server + '/projectPunishment/getProjectPunishmentPage' //行政列表 
export const update_punishment = app_server + '/projectPunishment/updatePunishment' //处罚 
export const addPunishmentTreatmentScheme = app_server + '/projectPunishment/addPunishmentTreatmentScheme' //处理
export const add_project_punishment = app_server + '/projectPunishment/addProjectPunishment'  //添加整改单
export const save_project_punishment = app_server + '/projectPunishment/saveProjectPunishment'  //暂存整改单
export const delProjectPunishment = app_server + '//projectPunishment/delProjectPunishment'  //整改单流程
export const getProjectPunishmentInfo = app_server + '/projectPunishment/getProjectPunishmentInfo'  //整改单详情
export const auditProjectPunishment = app_server + '/projectPunishment/auditProjectPunishment'  //整改单流程
export const feedbackList = app_server + '/feedback/getFeedback'  //列表
export const updateFeedback = app_server + '/feedback/updateFeedback'  //标记问题

export const projectPunishment_restartPunishmentApply = app_server + '/projectPunishment/restartPunishmentApply'  //重启流程
export const projectPunishment_delProjectPunishment = app_server + '/projectPunishment/delProjectPunishment'  //删除流程

export const data_all_pm = app_server + '/data/all_pm'  //客户经理查询他管理的项目总监

//详情页冻结处理状态列表数据
export const project_record = app_server + '/project/record'  //冻结处理状态列表数据

export const get_project_page = app_server + '/projectPunishment/getProjectPage'  //添加行政处罚 - 查询项目

//运营统计
export const get_report_orgList = app_server + '/reportOrg/getReportOrgList'  //组织架构
export const get_operation_report_menu = app_server + '/reportItem/getReportItemMenu'  //运营报表菜单 
export const get_report_item = app_server + '/reportItem/getReportItemData' //获取运营报表统计项信息数据

//用印申请
export const sealApplyAgreeOtherSealApply = app_server + '/sealApply/agreeOtherSealApply' //同意
export const sealApplyDisagreeOtherSealApply = app_server + '/sealApply/disagreeOtherSealApply' //拒绝
export const sealApplyReturnCustomFlowOtherSealApply = app_server + '/sealApply/returnCustomFlowOtherSealApply' //退回
export const sealApplyChangeOtherSealApply = app_server + '/sealApply/changeOtherSealApply' // 转交
export const sealApplyDelOtherSealApply = app_server + '/sealApply/delOtherSealApply' // 用印删除
export const sealApplyQueryOtherSealApply = app_server + '/sealApply/queryOtherSealApply' // 其他用印详情
export const sealApplySubmitOtherSealApply = app_server + '/sealApply/submitOtherSealApply' // 其他用印新增提交
export const sealApplySaveOtherSealApply = app_server + '/sealApply/saveOtherSealApply' // 其他用印新增保存
export const sealApplyGetOtherSealApplyPage = app_server + '/sealApply/getOtherSealApplyPage' // 其他用印列表
export const get_sealApply_file_category = app_server + '/enum_data/getSealApplyFileCategory' //文件类别
export const get_flow_node = app_server + '/flow/getFlowNodeOps' //当前环节
export const get_flow_process_progress = app_server + '/flow/getFlowProcessProgressOps' //办理进度
export const get_sealApply_category = app_server + '/enum_data/getEnumDataByLabel' //通用类别
export const get_approve_project = app_server + '/project/getApproveProjectBySignPage' //获取客户经理负责的项目审核通过 
export const update_other_sealapply = app_server + '/sealApply/updateOtherSealApply'
export const save_sealApply = app_server + '/sealApply/saveSealApply' //用印申请-保存
export const submit_sealApply = app_server + '/sealApply/submitSealApply' //用印申请-提交
export const query_sealApply = app_server + '/sealApply/querySealApply' //用印申请详情
export const get_sealApply_page = app_server + '/sealApply/getSealApplyPage' //用印申请列表
export const get_return_list = app_server + '/flow/getReturnNodeListByBizItemId' //退回环节
export const get_employees_account = app_server + '/back_user/getEmployeesAccount' //选择转交人
export const agree_sealApply = app_server + '/sealApply/agreeSealApply' //同意
export const disagree_sealApply = app_server + '/sealApply/disagreeSealApply' //拒绝
export const change_sealApply = app_server + '/sealApply/changeSealApply' //转交
export const return_flow_sealApply = app_server + '/sealApply/returnCustomFlowSealApply' //退回
export const del_sealApply = app_server + '/sealApply/delSealApply' //删除用印申请
export const sealApply_recycleExecute = app_server + '/sealApply/recycleExecute' //回收处理

//流程按钮接口
export const disagree_project_manager = app_server + '/projectManager/disagreeProjectManager'
export const agree_project_manager = app_server + '/projectManager/agreeProjectManager'
export const change_project_manager = app_server + '/projectManager/changeProjectManager'
export const return_project_manager = app_server + '/projectManager/returnProjectManager'
export const complete_project_manager = app_server + '/projectManager/completeProjectManager'
export const get_cm_list = app_server + '/proManager/backUserProjectManager_cm'
export const sealApply_attaches = app_server + '/sealApply/getSealApplyAttaches'   //获取本次用印提交的附件
export const update_pm_phone = app_server + '/proManager/updatePmPhone'



export const sealApply_restartSealApply = app_server + '/sealApply/restartSealApply'//用印-重启流程
export const sealApply_deleteRecycle = app_server + '/sealApply/deleteRecycle'//用印-删除回收信息

//员工证书
export const addPersonInfo = app_server + '/personInfo/addPersonInfo' //新增员工接口
export const getPersonInfoPage = app_server + '/personInfo/getPersonInfoPage' //员工列表接口
export const getPersonInfoById = app_server + '/personInfo/getPersonInfoById' //员工详情接口
export const delPersonInfoById = app_server + '/personInfo/delPersonInfoById' //删除员工接口
export const addQualificationCertificate = app_server + '/qualificationCertificate/addQualificationCertificate' //新增编辑证书接口
export const getQualificationCertificateList = app_server + '/qualificationCertificate/getQualificationCertificateList' //员工证书详情接口
export const delQualificationCertificatebyId = app_server + '/qualificationCertificate/delQualificationCertificatebyId' //删除员工证书接口
export const getCertificateApplyByPersonIdPage = app_server + '/certificateApply/getCertificateApplyByPersonIdPage' //员工详情用证申请列表接口
export const releasedCertificateApplyById = app_server + '/certificateApply/releasedCertificateApplyById' //解除使用/锁定证书接口
export const getOverdueQualificationCertificatePage = app_server + '/qualificationCertificate/getOverdueQualificationCertificatePage' //到期证书-已过期/即将过期接口
export const addCertificateApply = app_server + '/certificateApply/addCertificateApply' //锁定/使用证书接口
export const getRegisterTypeQualificationCertificateList = app_server + '/qualificationCertificate/getRegisterTypeQualificationCertificateList' //注册人员列表表头分类统计接口
export const getManageTypeQualificationCertificateList = app_server + '/qualificationCertificate/getManageTypeQualificationCertificateList' //管理人员列表表头分类统计接口
export const getRegisterQualificationCertificatePage = app_server + '/qualificationCertificate/getRegisterQualificationCertificatePage' //注册人员列表接口
export const getManageQualificationCertificatePage = app_server + '/qualificationCertificate/getManageQualificationCertificatePage' //管理人员列表接口
export const getSkillQualificationCertificatePage = app_server + '/qualificationCertificate/getSkillQualificationCertificatePage' //技术工人列表接口
export const certificateApply_getProjectPage = app_server + '/certificateApply/getProjectPage' //使用/锁定证书查询项目接口
export const qualificationCertificate_getManageMajorType = app_server + '/qualificationCertificate/getManageMajorType'  //岗位名称
export const getSafetyTypeQualificationCertificateList = app_server + '/qualificationCertificate/getSafetyTypeQualificationCertificateList';  //安证人员列表表头数量统计
export const getTitleTypeQualificationCertificateList = app_server + '/qualificationCertificate/getTitleTypeQualificationCertificateList';   //职称人员列表表头数量统计
export const getSafetyTypeQualificationCertificatePage = app_server + '/qualificationCertificate/getSafetyTypeQualificationCertificatePage';    //安证人员列表
export const getTitleTypeQualificationCertificatePage = app_server + '/qualificationCertificate/getTitleTypeQualificationCertificatePage';    //职称人员列表

export const validation_rules = app_server + '/apply/checkBacklogForProject'  // 校验是否存在代办申请的接口
//  首页接口
export const getEchartsSyntheticReportDataByLine = app_server + '/reportItem/getEchartsSyntheticReportDataByLine' // 获取综合数据报表
export const getEchartsProjectReportDataByLine = app_server + '/reportItem/getEchartsProjectReportDataByLine' // 获取项目数据报表
export const getAuthorizeBackRole = app_server + '/authorizeBackRole'  // 小程序跳转获取token
export const getXappReportMenuByRole = app_server + '/sysMenu/getXappReportMenuByRole'
// 首页 客户数据
export const getEchartsReportItemDataByCustomer = app_server + '/reportItem/getEchartsReportItemDataByCustomer'  // 甲方数据
export const getEchartsCustomerCountReportItemData = app_server + '/reportItem/getEchartsCustomerCountReportItemData'  // 获取客户数据
export const getEchartsCustomerNatureReportItemData = app_server + '/reportItem/getEchartsCustomerNatureReportItemData'  // 获取性质
export const getEchartsCustomerIndustryReportItemData = app_server + '/reportItem/getEchartsCustomerIndustryReportItemData'  // 获取行业
export const getEchartsRegisterReportItemData = app_server + '/reportItem/getEchartsRegisterReportItemData' // 获取入库备案
export const getEchartsStatusCountReportItemData = app_server + '/reportItem/getEchartsStatusCountReportItemData'  // 获取状态 
export const getEchartsChargeReportItemData = app_server + '/reportItem/getEchartsChargeReportItemData' // 获取收费
//  首页 精英数据
export const getEchartsReportItemDataByElite = app_server + '/reportItem/getEchartsReportItemDataByElite' // 总监数据总数
export const getEchartsTalentsCountReportItemData = app_server + '/reportItem/getEchartsTalentsCountReportItemData' //  精英数量
export const getEchartsTalentsPartnershipReportItemData = app_server + '/reportItem/getEchartsTalentsPartnershipReportItemData' // 获取合作
export const getEchartsTalentsTypeReportItemData = app_server + '/reportItem/getEchartsTalentsTypeReportItemData' // 获取精英类型
export const getEchartsRegisterAndManageReportItemData = app_server + '/reportItem/getEchartsRegisterAndManageReportItemData' // 获取注册人员/管理人员
export const getEchartsSkillReportItemData = app_server + '/reportItem/getEchartsSkillReportItemData' // 获取技术工人
// 首页 运营数据-立项数据
export const getEchartsInitiateReportDataBySource = app_server + '/reportItem/getEchartsInitiateReportDataBySource' // 立项数据
export const getEchartsInitiateReportDataByType = app_server + '/reportItem/getEchartsInitiateReportDataByType' // 项目类型
export const getEchartsInitiateReportDataByTrend = app_server + '/reportItem/getEchartsInitiateReportDataByTrend' // 立项走势
// 首页 运营数据-投标数据
export const getEchartsBidReportDataByTrend = app_server + '/reportItem/getEchartsBidReportDataByTrend' //投标走势
export const getEchartsBidReportDataBySource = app_server + '/reportItem/getEchartsBidReportDataBySource' // 投标项目来源
export const getEchartsBidReportDataByType = app_server + '/reportItem/getEchartsBidReportDataByType' // 投标项目类型
// 首页 运营数据-丢单数据
export const getEchartsLoseReportDataByTrend = app_server + '/reportItem/getEchartsLoseReportDataByTrend' // 丢单走势
export const getEchartsLoseReportDataByType = app_server + '/reportItem/getEchartsLoseReportDataByType' // 丢单项目类型
export const getEchartsLoseReportDataBySource = app_server + '/reportItem/getEchartsLoseReportDataBySource' // 丢单项目来源

// 首页 工程数据-异常数据
export const getEchartsAbnormalReportDataBySource = app_server + '/reportItem/getEchartsAbnormalReportDataBySource'
export const getEchartsAbnormalTypeReportItemData = app_server + '/reportItem/getEchartsAbnormalTypeReportItemData'

// 首页 工程数据-派单数据
export const getEchartsDispatchReportDataByTrend = app_server + '/reportItem/getEchartsDispatchReportDataByTrend'
export const getEchartsDispatchReportDataByRegion = app_server + '/reportItem/getEchartsDispatchReportDataByRegion'
export const getEchartsDispatchReportDataBySource = app_server + '/reportItem/getEchartsDispatchReportDataBySource'
export const getEchartsDispatchReportDataByGrade = app_server + '/reportItem/getEchartsDispatchReportDataByGrade'

// 首页 工程数据-巡检数据
export const getEchartsPollingReportDataByTrend = app_server + '/reportItem/getEchartsPollingReportDataByTrend'
export const getEchartsPollingReportDataByGrade = app_server + '/reportItem/getEchartsPollingReportDataByGrade'
export const getEchartsPollingReportDataByProject = app_server + '/reportItem/getEchartsPollingReportDataByProject'
export const getEchartsPollingReportDataByRegion = app_server + '/reportItem/getEchartsPollingReportDataByRegion'
export const getEchartsPollingReportDataByProjectScore = app_server + '/reportItem/getEchartsPollingReportDataByProjectScore'
export const getEchartsPollingReportDataByDirectorScore = app_server + '/reportItem/getEchartsPollingReportDataByDirectorScore'

// 首页 设计数据-设计数据
export const getEchartsDesignTypeReportItemData = app_server + '/reportItem/getEchartsDesignTypeReportItemData'
export const getEchartsDesignReportDataByRegion = app_server + '/reportItem/getEchartsDesignReportDataByRegion'
export const getEchartsDesignReportItemData = app_server + '/reportItem/getEchartsDesignReportItemData'
export const getEchartsDesignAbnormalTypeReportItemData = app_server + '/reportItem/getEchartsDesignAbnormalTypeReportItemData'

// 首页 运营数据-中标数据
export const getEchartsBiddingReportDataByCount = app_server + '/reportItem/getEchartsBiddingReportDataByCount' // 中标个数
export const getEchartsBiddingReportDataByMoney = app_server + '/reportItem/getEchartsBiddingReportDataByMoney' // 中标金额
export const getEchartsBiddingReportDataBySource = app_server + '/reportItem/getEchartsBiddingReportDataBySource' // 项目来源
export const getEchartsBiddingReportDataByType = app_server + '/reportItem/getEchartsBiddingReportDataByType' // 项目类型
export const getEchartsBiddingReportDataByProjectMoney = app_server + '/reportItem/getEchartsBiddingReportDataByProjectMoney' // 签约金额排名
export const getEchartsBiddingReportDataByDirectorMoney = app_server + '/reportItem/getEchartsBiddingReportDataByDirectorMoney' // 总监签约金额排名

// 首页 购销数据-购销数据
export const getEchartsBuyingTypeReportItemData = app_server + '/reportItem/getEchartsBuyingTypeReportItemData'
export const getEchartsBuyingReportDataByRegion = app_server + '/reportItem/getEchartsBuyingReportDataByRegion'
export const getEchartsBuyingReportItemData = app_server + '/reportItem/getEchartsBuyingReportItemData'
export const getEchartsBuyingAbnormalTypeReportItemData = app_server + '/reportItem/getEchartsBuyingAbnormalTypeReportItemData'

// 首页 财务数据-流水数据
export const getEchartsSummaryFinanceIncomeReportItemData = app_server + '/reportItem/getEchartsSummaryFinanceIncomeReportItemData' // 汇总(收款流水、支出流水)
export const getEchartsTrendFinanceIncomeData = app_server + '/reportItem/getEchartsTrendFinanceIncomeData' // 流水走势
export const getEchartsSummaryFinanceIncomeTypeReportItemData = app_server + '/reportItem/getEchartsSummaryFinanceIncomeTypeReportItemData' // 收款类型
export const getEchartsClaimedFinanceIncomeTypeReportItemData = app_server + '/reportItem/getEchartsClaimedFinanceIncomeTypeReportItemData' // 已认领收款占比
export const getEchartsFoldOrPostFinanceIncomeData = app_server + '/reportItem/getEchartsFoldOrPostFinanceIncomeData' // 付款类型

// 首页 财务数据-应收数据
export const financeReceivableSummaryReportItemData = app_server + '/reportItem/financeReceivableSummaryReportItemData' // 汇总数据
export const invoiceTicktReceivableReportItemData = app_server + '/reportItem/invoiceTicktReceivableReportItemData' // 开票金额&回款金额走势
export const payableReceivableReportItemData = app_server + '/reportItem/payableReceivableReportItemData' // 代付&回票金额走势

// 首页 财务数据-结算数据
export const getEchartsSettlementReportDataByProject = app_server + '/reportItem/getEchartsSettlementReportDataByProject'
export const getEchartsSettlementReportDataByType = app_server + '/reportItem/getEchartsSettlementReportDataByType'
export const getEchartsSettlementReportDataByCooperationType = app_server + '/reportItem/getEchartsSettlementReportDataByCooperationType'

// 首页 财务数据-应付数据
export const financeReturnedSummaryReportItemData = app_server + '/reportItem/financeReturnedSummaryReportItemData' // 应付汇总数据
export const payableReturnedReportItemData = app_server + '/reportItem/payableReturnedReportItemData' // 代付&实付金额走势
export const laborReturnedReportItemData = app_server + '/reportItem/laborReturnedReportItemData' // 劳务&实付金额走势export const payableReceivableReportItemData = app_server + '/reportItem/payableReceivableReportItemData' // 代付&回票金额走势

// 首页 运营数据-签约数据
export const getEchartsSignedReportDataByInfo = app_server + '/reportItem/getEchartsSignedReportDataByInfo' //签约信息 + 合同额 + 合同个数
export const getEchartsSignedReportDataByEngineeringType = app_server + '/reportItem/getEchartsSignedReportDataByEngineeringType' // 工程类型
export const getEchartsSignedReportDataByProjectType = app_server + '/reportItem/getEchartsSignedReportDataByProjectType' // 项目类型
export const getEchartsSignedReportDataByCooperationType = app_server + '/reportItem/getEchartsSignedReportDataByCooperationType' // 合作类型
export const getEchartsSignedReportDataByGrade = app_server + '/reportItem/getEchartsSignedReportDataByGrade' // 项目等级
export const getEchartsSignedReportDataByProjectMoney = app_server + '/reportItem/getEchartsSignedReportDataByProjectMoney' // 项目金额排行
export const getEchartsSignedReportDataByDirectorMoney = app_server + '/reportItem/getEchartsSignedReportDataByDirectorMoney' // 项目总监签约金额排行榜
export const getEchartsSignedReportDataByProjectNumber = app_server + '/reportItem/getEchartsSignedReportDataByProjectNumber' // 项目总监签约项目个数排行榜
export const getEchartsSignedReportDataByRegion = app_server + '/reportItem/getEchartsSignedReportDataByRegion' // 项目地区
export const getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber = app_server + '/reportItem/getEchartsProjectOrDesignOrBuyingIsMoneyAndNumber' // 工程、设计、购销 签约合同金额及签约数量
export const getEchartsBidsReportData = app_server + '/reportItem/getEchartsBidsReportData' // 招标数据
export const getEchartsBidsReportDataByTrend = app_server + '/reportItem/getEchartsBidsReportDataByTrend'
export const getEchartsBidsReportDataByProvince = app_server + '/reportItem/getEchartsBidsReportDataByProvince'
export const getEchartsBidsReportDataByMapOfChina = app_server + '/reportItem/getEchartsBidsReportDataByMapOfChina'

// 首页 工程数据-汇总数据
export const getEchartsCollectReportDataByProgressRatio = app_server + '/reportItem/getEchartsCollectReportDataByProgressRatio' // 进度比例
export const getEchartsCollectReportDataByDispatchRatio = app_server + '/reportItem/getEchartsCollectReportDataByDispatchRatio' // 派单比例
export const getEchartsCollectReportDataByRegion = app_server + '/reportItem/getEchartsCollectReportDataByRegion' // 地区数据
export const getEchartsCollectReportDataBySource = app_server + '/reportItem/getEchartsCollectReportDataBySource' // 报建项目
export const getEchartsCollectReportDataByGrade = app_server + '/reportItem/getEchartsCollectReportDataByGrade' // 项目等级

// 营销管理 派单管理 - 派单查询
export const getQueryCustomerIntentionPage = app_server + '/customerIntention/getQueryCustomerIntentionPage';
// 营销管理 案例宣传 - 宣传项目
export const getPublicizePage = app_server + '/publicize/getPublicizePage';
export const getPublicizeProjectChooseCount = app_server + '/project/getPublicizeProjectChooseCount';
export const addOrUpdProjectPublicize = app_server + '/publicize/addOrUpdProjectPublicize';
export const findProjectPublicizeById = app_server + '/publicize/findProjectPublicizeById';
//  客户管理 - 供应商
export const getSupplierPage = app_server + '/supplier/getSupplierPage';
export const findSupplierById = app_server + '/supplier/findSupplierById';
export const findSupplierIssuePageList = app_server + '/supplierIssue/findSupplierIssuePageList';
export const saveSupplierIssue = app_server + '/supplierIssue/saveSupplierIssue';
export const removeSupplierIssueById = app_server + '/supplierIssue/removeSupplierIssueById';
export const delSupplierIssueById = app_server + '/supplierIssue/delSupplierIssueById';
export const updateSupplierBlacklistsStatus = app_server + '/supplier/updateSupplierBlacklistsStatus';
export const getSupplierBlacklistsPageList = app_server + '/supplier/getSupplierBlacklistsPageList';
export const saveSupplier = app_server + '/supplier/saveSupplier';

// 工单管理
export const WorkOrderGetWorkOrderPage = app_server + '/workOrder/getWorkOrderPage'; // 列表
export const WorkOrderSaveWorkOrder = app_server + '/workOrder/saveWorkOrder'; // 新增
export const WorkOrderGetWorkOrderDelete = app_server + '/workOrder/getWorkOrderDelete'; // 删除
export const WorkOrderGetWorkOrderDetail = app_server + '/workOrder/getWorkOrderDetail'; // 详情
export const WorkOrderDisagreeWorkOrder = app_server + '/workOrder/disagreeWorkOrder';// 拒绝
export const WorkOrderAgreeWorkOrder = app_server + '/workOrder/agreeWorkOrder'; //同意
export const WorkOrderChangeWorkOrder = app_server + '/workOrder/changeWorkOrder'; //转交
export const WorkOrderReturnWorkOrder = app_server + '/workOrder/returnWorkOrder'; //退回
export const WorkOrderCompleteWorkOrder = app_server + '/workOrder/completeWorkOrder'; //完成处理
export const WorkOrderGetWorkTicketsNumber = app_server + '/workOrder/getWorkTicketsNumber'

export const eSignature = app_server + '/sign/eSignature';

// 数据大屏相关
export const getIndexSyntheticData = app_server + '/dataView/getSyntheticData'
export const getPmData = app_server + '/dataView/eliteInformation'
export const getProjectInformation = app_server + '/dataView/projectInformation'
export const getCustomerData = app_server + '/dataView/getCustomerDataShow'

export const NoticeGetSystemNoticePage = app_server + '/notice/getSystemNoticePage'

export const workbench_data = app_server + '/workbench_data'


// WEBPACK FOOTER //
// ./src/helper/Urls.js